<template>
  <div id="app">
    <el-container
      class="container"
      v-if="
        $route.path !== '/' &&
        $route.path !== '/single' &&
        $route.path !== '/qinli_app' &&
        $route.path !== '/booksSet' &&
        $route.path !== '/xdRegister' &&
        $route.path !== '/gfRegister' && $route.path !== '/gfEmail' &&
        $route.path !== '/enroll' &&
        $route.path !== '/filePreview' &&
        $route.path !== '/preview'&& $route.path !== '/progressOff' 
      "
    >
      <el-aside>
        <div class="system">
          <div class="organName">{{ mes.org_name }}</div>
          <div
            class="systemName"
            style="display: flex; align-items: center; gap: 8px"
          >
            {{ name_system }}
            <img
              v-if="mes.organ_class == '试用'"
              style="width: 45px; height: 21px"
              src="./assets/imgs/user/orgTrial.png"
              alt=""
              draggable="false"
            />
            <img
              v-else
              style="width: 45px; height: 21px"
              src="./assets/imgs/user/orgFormal.png"
              alt=""
              draggable="false"
            />
          </div>
        </div>
        <!-- 菜单栏 -->
        <div class="menuBox">
          <!--  allMenuList -->
          <div
            v-for="(item, index) in menuList"
            :key="item.id"
            class="itemBox"
            @click="item.id == 1 ? firstMenuChange(item, index) : ''"
          >
            <div
              :class="[
                'firstMenu_one',
                item.id == 1 && 'firstMenu_one_home',
                item.id == 1 && firstMenuCurrent === 1 && 'firstMenu_active',
              ]"
            >
              <div class="leftBox">
                <img
                  v-if="item.id !== 1"
                  class="icon"
                  :src="require(`./assets/image/new_icon/one_${item.id}.png`)"
                  alt=""
                />
                <img
                  v-if="item.id == 1 && firstMenuCurrent !== 1"
                  class="icon"
                  :src="require(`./assets/image/new_icon/one_${item.id}.png`)"
                  alt=""
                />
                <!--  :src="require(`./assets/image/${item.id}.png`)" -->
                <img
                  v-if="firstMenuCurrent === 1 && item.id == 1"
                  class="icon"
                  :src="
                    require(`./assets/image/new_icon/one_${item.id}_active.png`)
                  "
                  alt=""
                />
                <!-- :src="require(`./assets/image/${item.id}_active.png`)" -->

                <!-- <span v-if="item.title == '智能咨询' && !num_total">
                  {{ item.title }}
                </span> -->
                <span> {{ item.title }} </span>
              </div>
              <!-- <div class="rightBox" v-if="item.subMenuList">
                <i v-show="item.expand" class="el-icon-arrow-down"></i>
                <i v-show="!item.expand" class="el-icon-arrow-right"></i>
              </div> -->
            </div>
            <div class="subMenu_two" v-if="item.subMenuList">
              <div
                v-for="(subItem, index__) in item.subMenuList"
                :key="index__"
                :class="[
                  'subItemBox_two',
                  subMenuCurrent === subItem.id && 'subMenu_active_two',
                ]"
                @click="subItem.subMenuList ? '' : subMenuChange(subItem)"
                :style="
                  index__ % 2 === 0
                    ? 'width: calc(57% - 6px);'
                    : 'width: calc(43% - 6px);'
                "
              >
                <el-badge
                  v-if="subItem.title == '资源管理' && num_total > 0"
                  :value="num_total"
                  class="item"
                >
                  <span
                    v-if="!subItem.subMenuList"
                    :class="firstMenuCurrent !== subItem.id ? '' : ''"
                    style="
                      display: inline-block;
                      width: 100%;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                  >
                    {{ subItem.title }}</span
                  >
                </el-badge>
                <el-badge
                  v-else-if="subItem.title == '消息中心' && num_msg_total > 0"
                  is-dot
                  class="item"
                >
                  <span
                    v-if="!subItem.subMenuList"
                    :class="firstMenuCurrent !== subItem.id ? '' : ''"
                    style="
                      display: inline-block;
                      width: 100%;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                  >
                    {{ subItem.title }}</span
                  >
                </el-badge>
                <span
                  v-else-if="!subItem.subMenuList"
                  :class="firstMenuCurrent !== subItem.id ? '' : ''"
                  style="
                    display: inline-block;
                    width: 100%;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                  "
                >
                  {{ subItem.title }}</span
                >

                <el-dropdown
                  v-else
                  placement="bottom-start"
                  trigger="click"
                  @command="handleSubMenuClick"
                  :popper-append-to-body="false"
                >
                  <span
                    class="el-dropdown-link dropdown_tit"
                    :style="
                      firstMenuCurrent !== subItem.id ? '' : ' color: #e2426b;'
                    "
                  >
                    {{ subItem.title }}
                    <span
                      v-if="
                        subItem.title == '查重与校对' &&
                        (grammerNum > 0 || turnitinNum > 0)
                      "
                      class="badge_fixed__"
                      >{{ grammerNum + turnitinNum }}</span
                    >
                    <span
                      v-if="subItem.title == '文档翻译' && translateNum > 0"
                      class="badge_fixed__"
                      >{{ translateNum }}</span
                    >
                  </span>
                  <el-dropdown-menu class="menu_drop_css" slot="dropdown">
                    <el-dropdown-item
                      v-for="subItem_son in subItem.subMenuList"
                      :key="subItem_son.id"
                      :class="
                        subMenuCurrent == subItem_son.id ? 'is_drop_active' : ''
                      "
                      :command="{ parent: subItem, child: subItem_son }"
                    >
                      <span style="position: relative">
                        {{ subItem_son.title
                        }}<span
                          v-if="
                            subItem.title == '查重与校对' &&
                            subItem_son.title == '查看报告' &&
                            (grammerNum > 0 || turnitinNum > 0)
                          "
                          class="badge_fixed__"
                          >{{ grammerNum + turnitinNum }}</span
                        ><span
                        v-if="
                          subItem.title == '文档翻译' &&
                          subItem_son.title == '查看报告' &&
                          translateNum > 0
                        "
                        class="badge_fixed__"
                        >{{ translateNum }}</span
                      ></span
                      ></el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
          <!-- <div v-for="(item, index) in menuList" :key="item.id" class="itemBox">
            <el-divider v-if="[7, 12].includes(item.id)"></el-divider>
            <div
              :class="[
                'firstMenu',
                firstMenuCurrent === item.id && 'firstMenu_active',
              ]"
              @click="firstMenuChange(item, index)"
            >
              <div class="leftBox">
                <img
                  v-show="firstMenuCurrent !== item.id"
                  class="icon"
                  :src="require(`./assets/image/${item.id}.png`)"
                  alt=""
                />
                <img
                  v-show="firstMenuCurrent === item.id"
                  class="icon"
                  :src="require(`./assets/image/${item.id}_active.png`)"
                  alt=""
                />
                <el-badge
                  v-if="item.title == '智能咨询' && num_total"
                  :value="num_total"
                  class="item"
                >
                  {{ item.title }}
                </el-badge>
                <span v-if="item.title == '智能咨询' && !num_total">
                  {{ item.title }}
                </span>
                <span v-if="item.title !== '智能咨询'"> {{ item.title }} </span>
              </div>
              <div class="rightBox" v-if="item.subMenuList">
                <i v-show="item.expand" class="el-icon-arrow-down"></i>
                <i v-show="!item.expand" class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="subMenu" v-if="item.subMenuList && item.expand">
              <div
                v-for="subItem in item.subMenuList"
                :key="subItem.id"
                :class="[
                  'subItemBox',
                  subMenuCurrent === subItem.id && 'subMenu_active',
                ]"
                @click="subMenuChange(subItem)"
                :style="
                  !subItem.path
                    ? 'cursor:not-allowed;border: 1px solid #fff;color: #a8aaae;'
                    : ''
                "
              >
                <span
                  v-if="subItem.id !== 22"
                  :class="[
                    'circle',
                    subMenuCurrent === subItem.id && 'circle_active',
                  ]"
                ></span>
                <i
                  v-else
                  style="position: relative; left: -5px"
                  class="el-icon-lock"
                ></i>
                <el-badge
                  v-if="subItem.title == '资源管理' && num_total > 0"
                  :value="num_total"
                  class="item"
                >
                  {{ subItem.title }}
                </el-badge>
                <span v-if="subItem.title == '资源管理' && !num_total">
                  {{ subItem.title }}
                </span>
                <span
                  v-if="subItem.title !== '资源管理'"
                  :style="
                    subItem.id == 22 ? 'position: relative;left: -5px;' : ''
                  "
                >
                  {{ subItem.title }}
                </span>
              </div>
            </div>
          </div> -->
        </div>

        <div class="logo_area">
          <img src="./assets/image/logo.png" />
        </div>
      </el-aside>

      <el-container>
        <el-header height="80px">
          <div class="modelName">{{ modelName }}</div>
          <div class="userInfo" v-if="isRouterAlives">
            <!-- <el-divider></el-divider> -->
            <div class="content">
              <div
                class="xn_css_fu"
                :style="!xn_show ? '' : 'z-index: 2011 !important;'"
              >
                <div class="xn_css" v-if="mes.is_xuanniao" @click="go_xuanniao">
                  <img
                    style="width: 16px"
                    src="./assets/imgs/logo/Union.png"
                    alt=""
                  />
                  <span style="height: 22px; line-height: 22px"
                    >切换至玄鸟</span
                  >
                  <img
                    style="width: 24px"
                    src="./assets/imgs/logo/xuanniao_logo.png"
                    alt=""
                  />
                </div>
                <div class="xn_reminder" v-if="xn_show">
                  <div class="reminder_line"></div>
                  <div class="reminder_box">
                    <img src="./assets/imgs/user/xn_home.png" />
                    <div class="reminder_txt">
                      提供全流程AI科研辅助工具<br />助力论文选题、写作、数据分析、图表与PPT生成等<br />科研全流程任务高效完成
                    </div>
                    <div class="reminder_btn_s">
                      <div class="reminder_btn" @click="xn_show = false">
                        稍后注册
                      </div>
                      <div
                        class="reminder_btn"
                        style="
                          background: var(---, #f67416);
                          border-color: #e4e5e8;
                          color: #fff;
                        "
                        @click="go_xuanniao"
                      >
                        立即注册玄鸟
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 1px; background: #e6e6e6; height: 23px"></div>
              <div class="user">
                <el-avatar
                  v-if="
                    mes.avatarUrl &&
                    mes.avatarUrl !==
                      'https://thirdwx.qlogo.cn/mmopen/vi_32/POgEwh4mIHO4nibH0KlMECNjjGxQUq24ZEaGT4poC6icRiccVGKSyXwibcPq4BWmiaIGuG1icwxaQX6grC9VemZoJ8rg/132'
                  "
                  shape="square"
                  :size="40"
                  :src="mes.avatarUrl"
                ></el-avatar>
                <img
                  v-else
                  style="width: 40px"
                  src="./assets/imgs/2.2/user_2x.png"
                />
                <div class="mobile_css">
                  <div class="mobile">
                    {{ phone.replace(/x/g, "*") }}
                  </div>
                  <img
                    v-if="mes.id_photo_state === 2 || !mes.is_idphoto"
                    style="width: 90px; height: 22px"
                    src="./assets/imgs/user/userFormal.png"
                    alt=""
                    draggable="false"
                  />
                  <img
                    v-else
                    @click="openDialog_Cer"
                    style="width: 90px; height: 22px"
                    src="./assets/imgs/user/userTria.png"
                    alt=""
                    draggable="false"
                    :style="
                      mes.improve_rewards == '1' ? 'cursor: pointer;' : ''
                    "
                  />
                </div>
                <!-- <el-tag
                  v-if="mes.id_photo_state === 2 || !mes.is_idphoto"
                  size="small"
                  color="#d14e6c"
                  style="color: #fff"
                  >正式用户</el-tag
                >
                <el-tag v-else size="small" color="#d14e6c" style="color: #fff"
                  >临时用户</el-tag
                > -->
                <div style="line-height: 0">
                  <img
                    class="icon"
                    src="./assets/image/logout.png"
                    @click="loginOut"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="mes.attestation_state === 1 && mes.proveEnd"
              class="hint"
            >
              下次GPS认证开始时间：{{ mes.proveEnd }}
            </div>
            <div
              v-if="mes.attestation_state !== 1 && mes.gps_remainder"
              class="hint"
            >
              GPS认证剩余时间 {{ mes.gps_remainder }} 天
            </div>
          </div>
        </el-header>
        <!-- min-width: 1180px; -->
        <el-main style="padding: 0 !important; overflow: auto" class="main_css">
          <router-view v-if="isRouterAlives"></router-view>
        </el-main>
      </el-container>
    </el-container>
    <router-view
      v-if="
        ($route.path == '/' ||
          $route.path == '/single' ||
          $route.path == '/qinli_app' ||
          $route.path == '/enroll' ||
          $route.path == '/booksSet' ||
          $route.path == '/xdRegister' ||
          $route.path == '/gfRegister' ||$route.path == '/gfEmail' ||$route.path == '/progressOff' ||
          $route.path == '/filePreview' ||
          $route.path == '/preview') &&
        isRouterAlives
      "
    ></router-view>
    <!-- 注册信息 -->
    <el-dialog
      title="注册信息"
      :visible.sync="dialogFormVisible"
      :width="'500px'"
      :append-to-body="true"
    >
      <p class="tit_message">
        根据注册信息，我们获取到您的发文信息如下，我们会根据获取到的信息追踪相应的文献，请您核对发文名称是否正确。
      </p>
      <el-form :model="form">
        <el-form-item label="中文发文名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="英文发文名称" :label-width="formLabelWidth">
          <el-input v-model="form.en_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="所属机构" :label-width="formLabelWidth">
          <el-input disabled v-model="form.code" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="enroll">开始追踪</el-button>
      </div>
    </el-dialog>

    <!-- 单点登录完善个人信息 -->
    <el-dialog
      :visible.sync="dialogUserInfo"
      :width="'580px'"
      :append-to-body="true"
      custom-class="userInfo_css"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <!-- <p class="tit_dialog">
        欢迎您，<span v-if="mes.org_name">{{ mes.org_name }}的</span>老师~
      </p> -->
      <p class="tit_dialog">恭喜您已成功登录青梨PC端！</p>
      <!-- <p class="tit_fill">填写账户信息</p>
     
     <p class="tit_p">恭喜您已成功登录青梨PC端！</p> -->
      <p class="tit_fill">完善用户信息</p>
      <p class="tit_p">
        为优化服务体验，请您在90天内完善以下关键信息。感谢您的配合！
      </p>
      <el-form
        :model="userForm"
        :rules="rules"
        ref="userForm"
        style="margin: 20px 0 0 0"
      >
        <el-form-item label="姓名" :label-width="formLabelWidth_" prop="name">
          <el-input
            v-model="userForm.name"
            placeholder="请输入真实姓名"
            clearable
            @blur="userForm.name = trimText(userForm.name)"
            :disabled="!!trimText(userForm_copy.name)"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="院系/部门"
          :label-width="formLabelWidth_"
          prop="faculty"
        >
          <el-select
            v-model="userForm.faculty"
            clearable
            placeholder="请选择院系/部门"
            style="width: 100%"
            filterable
            @change="userForm.faculty = trimText(userForm.faculty)"
            :disabled="!!trimText(userForm_copy.faculty)"
          >
            <el-option
              v-for="item in facultyArry"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label=""
          :label-width="formLabelWidth_"
          prop="faculty"
          v-if="trimText(userForm.faculty) === '自定义'"
        >
          <!--  v-if="userForm.faculty == '其他'" -->
          <!-- placeholder="请输入其他 院系/部门" -->
          <el-input
            v-model="other_faculty"
            placeholder="请输入自定义 院系/部门"
            clearable
            @blur="other_faculty = trimText(other_faculty)"
            :disabled="!!trimText(userForm_copy.faculty)"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="手机号"
          :label-width="formLabelWidth_"
          prop="phone"
        >
          <el-input
            v-model="userForm.phone"
            placeholder="请输入手机号"
            clearable
          ></el-input>
        </el-form-item> -->

        <el-form-item label="邮箱" :label-width="formLabelWidth_">
          <!-- prop="email" -->
          <el-input
            v-model="userForm.email"
            placeholder="请输入邮箱"
            clearable
            :disabled="userForm_copy.email ? true : false"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="邮箱验证码"
          :label-width="formLabelWidth_"
          prop="email_code"
        >
          <el-input v-model="userForm.email_code" placeholder="邮箱验证码">
            <div class="get_code_css" slot="suffix" @click="getCode">
              {{ isCountingDown ? `${countdown}s` : "获取验证码" }}
            </div>
          </el-input>
        </el-form-item> -->
        <el-form-item label="工号" :label-width="formLabelWidth_">
          <el-input
            v-model="userForm.jobNumber"
            placeholder="请输入工号"
            clearable
            :disabled="userForm_copy.jobNumber ? true : false"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="user_dialog_footer">
        <el-button
          type="primary"
          @click="refineLater"
          v-if="remainderDay > 0"
          style="
            color: var(---, #262729);
            background: var(---300, #f1f2f2);
            border: none !important;
          "
          >稍后完善</el-button
        >
        <!-- dialogUserInfo = false -->
        <el-button
          type="primary"
          @click="subInfo('userForm')"
          style="
            color: var(--white-dark-white, #fff);
            background: #e2426b;
            border: none !important;
          "
          >确定</el-button
        >
      </div>
      <p class="bottom_p">
        <span>剩余时间：{{ remainderDay }} 天</span>
        &emsp;前往【我的】>【个人信息】页面完善即可
      </p>
    </el-dialog>
    <!-- 提示弹框 -->

    <el-dialog
      title="绑定微信"
      :visible.sync="dialogPrompt"
      width="580px"
      class="message"
      custom-class="userInfo_css"
    >
      <p class="tit_fill">绑定微信</p>
      <p style="color: var(---, #6b6e73); line-height: 24px">
        前往【我的】>【个人信息】进行绑定，绑定后，在微信中搜索“青梨AI科研服务平台”，即可体验青梨移动端服务！
      </p>

      <div style="padding: 24px; display: flex; justify-content: flex-end">
        <el-button
          style="
            color: var(---, #262729);
            background: var(---300, #f1f2f2);
            border: none !important;
          "
          class="dialog_btn"
          @click="dialogPrompt = false"
          >稍后绑定</el-button
        >
        <el-button
          style="
            color: var(--white-dark-white, #fff);
            background: #e2426b;
            border: none !important;
          "
          type="primary"
          @click="go_Bind"
          class="dialog_btn"
          :loading="loadingBind"
          >去绑定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogProductExpired"
      width="480px"
      custom-class="product-expired-dialog"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div slot="title" class="product-expired-dialog__title">提示</div>
      <div class="product-expired-dialog__body">
        <p class="product-expired-dialog__text">
          试用权限已到期，如需继续使用，请联系销售负责人重新开通
        </p>
        <p class="product-expired-dialog__contact" v-if="mes.sale_phone">
          联系人：{{ mes.sale_name }} {{ mes.sale_phone }}
        </p>
        <p class="product-expired-dialog__contact" v-else>
          联系人：李明 18616263366
        </p>
      </div>
      <div class="product-expired-dialog__footer">
        <el-button
          type="primary"
          class="product-expired-dialog__btn"
          @click="dialogProductExpired = false"
        >关闭</el-button>
      </div>
    </el-dialog>
    <!-- 扫码绑定 -->
    <el-dialog
      :visible.sync="dialogUserGarden"
      :width="'580px'"
      :append-to-body="true"
      custom-class="userInfo_css"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <p class="tit_fill">绑定微信</p>

      <p class="tit_p" style="font-size: 16px">
        打开微信“扫一扫”扫描下方二维码绑定，享受更便捷的移动端服务体验
      </p>
      <div
        class="code_img_css"
        style="display: flex; justify-content: center; align-items: center"
        :style="!bindImg ? 'height:250px;' : ''"
        v-loading="!bindImg"
        element-loading-text="生成中..."
        element-loading-spinner="el-icon-loading"
      >
        <img
          style="width: 210px; margin: 20px 0"
          v-if="bindImg"
          :src="bindImg"
          alt=""
        />
      </div>

      <div class="user_dialog_footer">
        <el-button
          type="primary"
          @click="downShutBind()"
          style="
            color: var(---, #262729);
            background: var(---300, #f1f2f2);
            border: none !important;
          "
          >稍后绑定</el-button
        >
        <!-- <el-button
          type="primary"
          @click="downShutBind()"
          style="
            color: var(--white-dark-white, #fff);
            background: #e2426b;
            border: none !important;
          "
          >关闭</el-button
        > -->
      </div>
      <p class="bottom_p" style="font-size: 16px; margin: 30px 0 0 0">
        绑定后，在微信中搜索“青梨A科研服务平台”，即可体验青梨移动端服务
      </p>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="gpsshow"
      :width="'550px'"
      :append-to-body="true"
      :close-on-click-modal="is_close"
      :show-close="is_close"
      custom-class="userInfo_css"
      :close-on-press-escape="is_close"
    >
      <!-- <p>根据注册信息，我们获取到您大致的中外文发文名称和机构，我们会根据获取到的信息追踪相应的文献。</p>
      <p>我们获取到的您的发文信息如下，请您核对发文名称是否正确。</p> -->
      <p class="tit_fill">重要提示</p>
      <p class="tit_p" style="font-size: 16px">
       <span v-if="mes.is_before_july31_gps_auth">假期将至，</span>临期老师，请尽早完成GPS认证，确保正常使用！手机端点击“GPS认证”或进入“我的页面
        >> 机构认证”完成操作。
      </p>
      <p class="tit_p" style="margin: 15px 0; color: red; text-align: center">
        剩余认证时间：<span>{{ gps_remainder }}</span
        >&nbsp;&nbsp;天&nbsp;&nbsp; 逾期将无法使用
      </p>

      <div style="text-align: center">
        <el-button
          v-if="sing_on_or"
          style="
            color: var(--white-dark-white, #fff);
            background: #e2426b;
            border: none !important;
            margin: 10px 0 20px 0;
          "
          type="primary"
          @click="go_Bind"
          class="dialog_btn"
          :loading="loadingBind"
          >绑定微信并认证</el-button
        >
        <!-- <span>{{ !sing_on_or ? "认证" : "绑定" }}</span> -->
        <img
          v-if="!sing_on_or"
          style="width: 45%"
          src="./assets/xx.jpg"
          alt=""
        />
        <!-- <div
          v-if="sing_on_or"
          class="code_img_css"
          style="display: flex; justify-content: center; align-items: center"
          :style="!bindImg ? 'height:250px;' : ''"
          v-loading="!bindImg"
          element-loading-text="生成中..."
          element-loading-spinner="el-icon-loading"
        >
          <img
            style="width: 210px; margin: 20px 0"
            v-if="sing_on_or && bindImg"
            :src="bindImg"
            alt=""
          />
        </div> -->
      </div>
      <p
        v-if="!sing_on_or"
        class="tit_message"
        style="
          text-align: center;
          color: #333;
          margin: 30px 0 0 0;
          text-indent: 0;
        "
      >
        微信扫一扫进入小程序
      </p>
      <div slot="footer" class="dialog-footer" v-if="is_close">
        <el-button type="primary" @click="gpsshow = false">稍后</el-button>
      </div>
    </el-dialog>
    <div
      class="kefu_css"
      v-if="orCustomer"
      :style="{ top: posY - 120 + 'px', left: posX + 'px' }"
      @mousedown="startDrag"
      ref="notification"
    >
      <!-- <el-popover placement="top" width="230" trigger="hover">
        <img style="width: 200px;" src="./assets/imgs/2.2/kefu_code.png" alt="">
        <div slot="reference">
          <i class="el-icon-circle-close" @click.stop="offCustomer"></i>
          <img
            @click="openCustomer()"
            style="z-index: 2001; width: 140px"
            src="./assets/imgs/2.2/kefu.png"
            alt=""
            draggable="false"
          />
         
        </div>
      </el-popover> -->
      <div
        class="kefu_wrapper"
        @mouseenter="isExpanded = true"
        @mouseleave="onMouseLeave"
        :class="{ expanded: isExpanded }"
      >
        <div class="kefu_css_">
          <i class="el-icon-circle-close" @click.stop="offCustomer"></i>
          <img
            style="z-index: 2001; width: 60px"
            src="./assets/imgs/app/kefu_.png"
            alt=""
            draggable="false"
          />
          <div class="cssSuspended">
            <!-- <el-popover placement="left" width="120" trigger="hover">
              <p style="text-align: center;"><span ></span></p>
             
             
            </el-popover> -->
            <el-tooltip
              class="item"
              effect="dark"
              content="电脑已登录微信，点击按钮咨询。"
              placement="left"
            >
              <div class="place_css" @click="openCustomer()">
                <div></div>
              </div>
            </el-tooltip>
            <el-popover placement="left" width="230" trigger="hover">
              <img
                style="width: 200px"
                src="./assets/imgs/2.2/kefu_code.png"
                alt=""
              />
              <div class="place_css" slot="reference">
                <div></div>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
    </div>
    <div class="mask_css" v-if="xn_show"></div>
    <el-dialog
      title=""
      :visible.sync="showCer"
      :width="'640px'"
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="userInfo_css cer_css"
    >
      <img
        style="width: 100%; border-radius: 8px 8px 0 0"
        src="./assets/imgs/user/bagCer.png"
        alt=""
      />
      <i
        style="
          position: absolute;
          right: 12px;
          top: 10px;
          font-size: 24px;
          color: #000;
          cursor: pointer;
        "
        class="el-icon-error"
        @click="showCer = false"
      ></i>
      <div class="cer_box">
        <div class="cer_box_txt">
          尊敬的用户：<br />&emsp;&emsp;您好！为答谢您的支持，我们特别为您准备了一份专属福利。为确保您顺利获得福利，同时以便我们为您提供更优质的服务，请您补充完善个人信息并完成证件认证，完成后奖励将自动发放。以下是福利内容：
        </div>
        <div class="cer_box_card">
          <div class="cer_box_card_tag">权益升级奖励</div>
          <div class="cer_box_card_txt">
            <!-- <span>●</span> -->
            <span style="max-width: calc(100% - 10px)"
              >在您完成证件认证后，您将自动升级为认证账号，享受比临时用户多<span
                style="color: #f01001; font-weight: 600"
              >
                100% </span
              >的权益。如下图所示：</span
            >
          </div>
          <div class="cer_box_line"></div>
          <div class="cer_box_con">
            <div class="cer_box_con_left">
              <div class="reward_tab">
                <div class="tab_th_1">
                  <div
                    class="tab_td_1"
                    style="color: #a1a1aa; background: #f7f7f7"
                  >
                    类型
                  </div>
                  <div
                    class="tab_td_1"
                    v-for="(item, index) in user_trial_array"
                    :key="index"
                    :style="
                      index % 2 === 0
                        ? 'background-color:#FFF'
                        : 'background-color:#F7F7F7'
                    "
                  >
                    {{
                      item.key == "book_num"
                        ? "图书查找量"
                        : item.key == "total_num"
                        ? "文献查找量"
                        : item.key == "grammer_extend"
                        ? "校对"
                        : item.key == "turnitin_extend"
                        ? "查重"
                        : item.key == "yicai"
                        ? "翻译"
                        : "--"
                    }}
                  </div>
                  <div
                    class="tab_td_1"
                    :style="
                      user_trial_array.length % 2 === 0
                        ? 'background-color:#FFF'
                        : 'background-color:#F7F7F7'
                    "
                  >
                    智能选刊
                  </div>
                </div>
                <div class="tab_th_2">
                  <div
                    class="tab_td_2"
                    style="color: #a1a1aa; background: #f7f7f7"
                  >
                    未认证账号
                  </div>
                  <div
                    class="tab_td_1"
                    v-for="(item, index) in user_trial_array"
                    :key="index"
                    :style="
                      index % 2 === 0
                        ? 'background-color:#FFF'
                        : 'background-color:#F7F7F7'
                    "
                  >
                    {{ user_trial[item.key] }}
                  </div>
                  <div
                    class="tab_td_1"
                    :style="
                      user_trial_array.length % 2 === 0
                        ? 'background-color:#FFF'
                        : 'background-color:#F7F7F7'
                    "
                  >
                    --
                  </div>
                </div>

                <div class="tab_th_4">
                  <div class="tab_td_4" style="color: #ad5200">已认证账号</div>
                  <div
                    class="tab_td_1"
                    style="color: #ad5200; font-weight: 500"
                    v-for="(item, index) in user_trial_array"
                    :key="index"
                  >
                    {{ user_formal[item.key] }}
                  </div>
                  <div
                    class="tab_td_1"
                    style="color: #ad5200; font-weight: 500"
                  >
                    免费开通
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="cer_box_con_line" style="width: 1px;background:  #e1e1e2;">
              
            </div> -->
            <div
              class="cer_box_con_right"
              v-if="mes.id_photo_state == 2 || !mes.is_idphoto"
            >
              <img
                style="width: 128px; height: 128px; margin: 0 auto"
                src="./assets/imgs/user/verified.png"
                alt=""
              />
              <div
                class="bottom_txt"
                style="color: #000; font-size: 16px; line-height: 24px"
              >
                已完成认证
              </div>
              <div
                class="bottom_txt"
                style="color: #aaadb5; font-size: 12px; line-height: 20px"
              >
                尊享认证权益
              </div>
            </div>
            <div class="cer_box_con_right" v-else>
              <div class="cer_box_con_right_top">
                <div
                  style="
                    color: #000;
                    font-size: 16px;
                    line-height: 24px;
                    text-align: center;
                  "
                >
                  扫码完成认证
                </div>
                <div
                  style="
                    color: #aaadb5;
                    font-size: 12px;
                    line-height: 20px;
                    text-align: center;
                  "
                >
                  使用微信扫描下方二维码进行认证
                </div>
              </div>
              <img style="width: 152px" src="./assets/xx.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { organinfo } from "@/Api/journals";
import {
  newUnreadNumber,
  extend_readNumber,
  cat_unreadNumber,
} from "@/Api/manage";
import bus from "@/utils/eventBus";
import {
  personalMessage,
  fetchMessage,
  phoneRegister,
  serachDepartment,
  userComplete,
  emailRegister,
  appletWx,
  xnUseraAes,
  permissionUser,
} from "@/Api/userMessage";
import { eventBus } from "./eventBus";
import {
  getUser,
  judge_user,
  confirmUser,
  organ_association,
} from "@/Api/unquote";
export default {
  name: "App",
  data() {
    const allMenuList = [
      { id: 1, title: "首页", path: "home", name: "home" },
      {
        id: 2,
        title: "智能咨询",
        expand: false,
        name: "Search",
        subMenuList: [
          // { id: 21, title: "咨询记录", path: "/search?webPage=1", parentId: 2 },
          { id: 21, title: "文献查找", path: "/search?webPage=1", parentId: 2 },
          //{ id: 22, title: "文献查找", path: "/search?webPage=2", parentId: 2 },
          {
            id: 22,
            title: "多模型问答",
            path: "/search?webPage=3",
            parentId: 2,
          },
          { id: 23, title: "资源管理", path: "/search?webPage=2", parentId: 2 },
          // { id: 24, title: "更多工具", path: "/search?webPage=4", parentId: 2 },
        ],
      },
      {
        id: 15,
        title: "科研工具",
        expand: false,
        name: "Dissertation",
        subMenuList: [
          {
            id: 3,
            title: "查重与校对",
            expand: false,
            name: "Dissertation",
            subMenuList: [
              {
                id: 31,
                title: "英文查重",
                path: "/dissertation?webPage=1",
                parentId: 3,
              },
              {
                id: 32,
                title: "语法校对",
                path: "/dissertation?webPage=2",
                parentId: 3,
              },
              // { id: 33, title: '语法校对 - Writeful', path:'/dissertation?webPage=4', parentId: 3 },
              {
                id: 34,
                title: "查看报告",
                path: "/dissertation?webPage=3",
                parentId: 3,
              },
            ],
          },
          {
            id: 4,
            title: "文档翻译",
            expand: false,
            name: "Translation",
            subMenuList: [
              {
                id: 41,
                title: "文件上传",
                path: "/translation?webPage=1",
                parentId: 4,
              },
              {
                id: 42,
                title: "查看报告",
                path: "/translation?webPage=2",
                parentId: 4,
              },
            ],
          },
          {
            id: 5,
            title: "学术推送",
            expand: false,
            name: "Academic",
            subMenuList: [
              {
                id: 51,
                title: "中文期刊推荐",
                path: "/academic?webPage=1",
                parentId: 5,
              },
              {
                id: 52,
                title: "英文期刊推荐",
                path: "/academic?webPage=2",
                parentId: 5,
              },
              // { id: 53, title: '机构订阅', path:'/academic?webPage=4', parentId: 5 },
              {
                id: 54,
                title: "个人中心",
                path: "/academic?webPage=3",
                parentId: 5,
              },
            ],
          },
          {
            id: 6,
            title: "引文追踪",
            expand: false,
            name: "Citation",
            subMenuList: [
              {
                id: 61,
                title: "中文文献追踪",
                path: "/citation?webPage=1",
                parentId: 6,
              },
              {
                id: 62,
                title: "英文文献追踪",
                path: "/citation?webPage=2",
                parentId: 6,
              },
              {
                id: 63,
                title: "任务列表",
                path: "/citation?webPage=3",
                parentId: 6,
              },
              {
                id: 64,
                title: "个人中心",
                path: "/citation?webPage=4",
                parentId: 6,
              },
            ],
          },
          {
            id: 14,
            title: "智能选刊",
            type: "external",
            // path: "https://chatresearch.newacademic.net/",
            path: "https://chatjournalselect.newacademic.net/",
            name: "Chat选刊",
          },
          {
            id: 7,
            title: "AI馆员",
            type: "external",
            path: "https://chatanswer.newacademic.net/",
            name: "ai",
          },
          { id: 24, title: "更多工具", path: "/search?webPage=4", parentId: 2 },
        ],
      },

      {
        id: 16,
        title: "资源库",
        expand: false,
        name: "Dissertation",
        subMenuList: [
          {
            id: 14,
            title: "ChatResearch",
            type: "external",
            path: "https://chatresearch.newacademic.net/",
            // path: "https://testchatresearch.newacademic.net/",
            name: "chatresearch",
            id_product: null,
          },
          {
            id: 8,
            title: "新知发现",
            type: "external",
            path: "https://scholar.newacademic.net/#/home",
            name: "knowledge",
            id_product: 25,
          },

          {
            id: 10,
            title: "高影响力期刊",
            type: "external",
            path: "https://search.newacademic.net/#/index",
            name: "journal",
            id_product: 1,
          },
          {
            id: 9,
            title: "学位论文",
            type: "external",
            path: "https://dissertation.newacademic.net/#/index",
            name: "wdl",
            id_product: 14,
          },
          {
            id: 24,
            title: "新知医学",
            type: "external",
            path: "https://newmed.newacademic.net/#/login",
            name: "mscholar",
            id_product: 25,
          },
        ],
      },

      // { id: 11, title: '历史' },
      {
        id: 12,
        title: "我的",
        expand: false,
        name: "Personal",
        subMenuList: [
          {
            id: 121,
            title: "个人信息",
            path: "/personal?webPage=1",
            parentId: 12,
          },
          {
            id: 124,
            title: "帮助中心",
            path: "/personal?webPage=4",
            parentId: 12,
          },
          {
            id: 122,
            title: "反馈问题",
            path: "/personal?webPage=2",
            parentId: 12,
          },
          {
            id: 123,
            title: "消息中心",
            path: "/personal?webPage=3",
            parentId: 12,
          },
        ],
      },
    ];
    return {
      firstMenuCurrent: 1,
      subMenuCurrent: null,
      allMenuList,

      gps_remainder: "",
      gps_term: "",
      is_close: false,
      gpsshow: false,
      activeIndex: "Search",
      name: "",
      email: "",
      phone: "",
      total: null,
      mes: {
        push_extend: true,
        is_hidden: true,
        track_extend: true,
        grammer_extend: false,
        turnitin_extend: false,
        yicai_extend: false,
      },
      dialogFormVisible: false,
      formLabelWidth: "120px",
      dialogUserGarden: false,
      dialogUserInfo: false,
      form: {
        name: "",
        en_name: "",
        code: "",
      },
      formLabelWidth_: "100px",
      userForm: {
        user_id: "",
        organ_code: "",
        name: "",
        faculty: "",
        // phone: "",
        email: "",
        jobNumber: "",
        // phone_code: "",
        // email_code: "",
      },
      userForm_copy: {
        user_id: "",
        organ_code: "",
        name: "",
        faculty: "",
        // phone: "",
        email: "",
        jobNumber: "",
        // phone_code: "",
        // email_code: "",
      },
      rules: {
        name: [{ required: true, message: "请输入真实姓名", trigger: "blur" }],
        faculty: [
          { required: true, message: "请选择院系/部门", trigger: "change" },
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        phone_code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        // email_code: [
        //   { required: true, message: "请输入邮箱验证码", trigger: "blur" },
        // ],
        // email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        // jobNumber: [{ required: true, message: "请输入工号", trigger: "blur" }],
      },
      other_faculty: "",
      isCountingDown: false,
      countdown: 60,
      countdownTimer: null,
      facultyArry: [],
      remainderDay: 0,

      enName: "",
      showInfo: false,
      banned_show: false,
      organ_product: [],
      dialogProductExpired: false,
      show_: true,
      openIndex: null,
      isRouterAlives: true,
      logoutDisabled: false,
      num_total: 0,
      _lastEventBusNumAt: 0,
      _lastEventBusNum: 0,
      grammerNum: 0,
      turnitinNum: 0,
      translateNum: 0,
      num_msg_total: 0,
      intervalId: null,
      disable_group_s: [
        "39053605528@chatroom",
        "56530986784@chatroom",
        "52571019643@chatroom",
        "38696601715@chatroom",
        "35034516726@chatroom",
        "38802985139@chatroom",
        "39227070897@chatroom",
        "20679458060@chatroom",
        "34517104569@chatroom",
        "34903209947@chatroom",
        "34496301855@chatroom",
        "44071109340@chatroom",
        "44558909279@chatroom",
        "49983741456@chatroom",
        // "44094707619@chatroom",
        "45496379845@chatroom",
        "44552503109@chatroom",
        "44910989359@chatroom",
        "39244616932@chatroom",
        "39304327028@chatroom",
        "22582410266@chatroom",
        "34462242436@chatroom",
        "38678517676@chatroom",
        "22018629545@chatroom",
        "23843205420@chatroom",
        "25639799054@chatroom",
        "25206716703@chatroom",
        // "23887022323@chatroom",
        "25094686337@chatroom",
        "25682179786@chatroom",
        "23524403013@chatroom",
        "23525613804@chatroom",
        "24166403217@chatroom",
        "22491014284@chatroom",
        "23108123075@chatroom",
        "24252511613@chatroom",
        "25107783359@chatroom",
        "20874107163@chatroom",
        "22337408040@chatroom",
        "22604806822@chatroom",
        // "24986167058@chatroom",
        "17414825312@chatroom",
        // "25295060073@chatroom",
        "23992692252@chatroom",
        "20231297349@chatroom",
        "20553498375@chatroom",
        "14029975295@chatroom",
        "20126095437@chatroom",
        "17227369353@chatroom",
      ],
      dialogPrompt: false,
      bindImg: "",
      loadingBind: false,
      intervalTimer: null,
      orCustomer: true,
      dragStartTime: 0,
      posX: 0, // 初始 X 坐标
      posY: 0, // 初始 Y 坐标
      offsetX: 0, // 鼠标点击时的偏移 X
      offsetY: 0,
      isDragging: false,
      isExpanded: false,
      sing_on_or: false,
      xn_show: false,
      showCer: false,
      user_formal: {},
      user_trial: {},
      user_trial_array: [],
    };
  },
  provide() {
    return {
      reloads: this.reloads,
    };
  },
  computed: {
    modelName() {
      console.log(this.subMenuCurrent);
      if (this.subMenuCurrent) {
        return this.findMenuTitleById(this.allMenuList, this.subMenuCurrent);
      } else {
        return this.findMenuTitleById(this.allMenuList, this.firstMenuCurrent);
      }
    },
    setCurrentMenuByPath(name, fullPath) {
      console.log(name, fullPath);
      if (!fullPath) return; // 安全校验，避免 undefined 报错
      console.log(this.firstMenuCurrent);
      let found = false;

      const traverse = (list) => {
        for (let item of list) {
          // 一级菜单匹配
          if (item.name === name) {
            this.firstMenuCurrent = item.id;
            item.expand = true;
          }

          // 匹配路径，支持二级、三级菜单
          if (item.path && fullPath.includes(item.path)) {
            this.subMenuCurrent = item.id;
            found = true;
            return;
          }

          // 遍历子菜单
          if (item.subMenuList && item.subMenuList.length > 0) {
            traverse(item.subMenuList);
            if (found) return;
          }
        }
      };

      traverse(this.allMenuList);

      if (!found) {
        // 如果没找到，则回退到 sessionStorage 或默认值
        const menuCurrent = JSON.parse(sessionStorage.getItem("menuCurrent"));
        if (menuCurrent) {
          this.firstMenuCurrent = menuCurrent.firstMenuCurrent;
          this.subMenuCurrent = menuCurrent.subMenuCurrent;

          const firstMenuItem = this.allMenuList.find(
            (item) => item.id === this.firstMenuCurrent
          );
          if (firstMenuItem && firstMenuItem.subMenuList) {
            firstMenuItem.expand = true;
          }
        } else {
          // 默认回退
          this.firstMenuCurrent = 1;
          this.subMenuCurrent = null;
        }
      }
    },

    menuList() {
      let id_photo_state = sessionStorage.getItem("id_photo_state")
        ? sessionStorage.getItem("id_photo_state")
        : "2";
      return this.allMenuList
        .map((item) => {
          // 屏蔽条件
          if (
            [3, 4, 5, 6, 7, 8, 9, 10, 14].includes(item.id) &&
            this.disable_group_s.includes(this.mes.belong_id)
          ) {
            return null;
          }

          // 一级或二级固定显示
          if ([1, 2, 7, 11, 12].includes(item.id)) {
            return { ...item };
          }
          if (
            item.id === 3 &&
            (this.mes.grammer_extend ||
              this.mes.turnitin_extend ||
              this.mes.is_hidden)
          ) {
            return { ...item };
          }
          if (
            item.id === 4 &&
            (this.mes.yicai_extend || this.mes.is_hidden)
          ) {
            return { ...item };
          }
          if (item.id === 14 || item.id === 24) {
            // &&
            // (id_photo_state == "2" || !this.mes.is_idphoto) &&
            // this.mes.identity == "在职员工"
            return { ...item };
          }
          // 特殊条件
          if (item.id === 5 && (this.mes.push_extend || this.mes.is_hidden))
            return { ...item };
          if (item.id === 6 && (this.mes.track_extend || this.mes.is_hidden))
            return { ...item };

          // 根据 organ_product 判断
          const organFlag = { 8: 25, 9: 14, 10: 1, 13: 24 };
          // 14: 1
          if (organFlag[item.id]) {
            const flag = this.organ_product.find(
              (v) => v.id === organFlag[item.id]
            );
            if (flag) return { ...item };
          }

          // 处理子菜单（递归）
          if (item.subMenuList && item.subMenuList.length > 0) {
            const filteredSub = item.subMenuList
              .map((subItem) => {
                // 二级逻辑和三级逻辑相同
                if (
                  [3, 4, 5, 6, 7, 8, 9, 10, 14].includes(subItem.id) &&
                  this.disable_group_s.includes(this.mes.belong_id)
                )
                  return null;

                if ([1, 2, 7, 11, 12].includes(subItem.id))
                  return { ...subItem };
                if (subItem.id === 3) {
                  if (!this.canShowDissertationMenu()) return null;
                  if (subItem.subMenuList && subItem.subMenuList.length > 0) {
                    const filteredThird = this.filterDissertationSubMenu(
                      subItem.subMenuList
                    );
                    if (!filteredThird.length) return null;
                    return { ...subItem, subMenuList: filteredThird };
                  }
                  return { ...subItem };
                }
                if (subItem.id === 4) {
                  if (!this.canShowTranslationMenu()) return null;
                  if (subItem.subMenuList && subItem.subMenuList.length > 0) {
                    const filteredThird = this.filterTranslationSubMenu(
                      subItem.subMenuList
                    );
                    if (!filteredThird.length) return null;
                    return { ...subItem, subMenuList: filteredThird };
                  }
                  return { ...subItem };
                }
                if (subItem.id === 14 || subItem.id === 24) {
                  //  (id_photo_state == "2" || !this.mes.is_idphoto) &&
                  // this.mes.identity == "在职员工"
                  return { ...subItem };
                }
                if (
                  subItem.id === 5 &&
                  (this.mes.push_extend || this.mes.is_hidden)
                )
                  return { ...subItem };
                if (
                  subItem.id === 6 &&
                  (this.mes.track_extend || this.mes.is_hidden)
                )
                  return { ...subItem };

                if (organFlag[subItem.id]) {
                  const flag = this.organ_product.find(
                    (v) => v.id === organFlag[subItem.id]
                  );
                  if (flag) return { ...subItem };
                }

                // 三级菜单
                if (subItem.subMenuList && subItem.subMenuList.length > 0) {
                  const filteredThird = subItem.subMenuList
                    .map((thirdItem) => {
                      if (
                        [3, 4, 5, 6, 7, 8, 9, 10, 14].includes(thirdItem.id) &&
                        this.disable_group_s.includes(this.mes.belong_id)
                      )
                        return null;

                      if ([1, 2, 7, 11, 12].includes(thirdItem.id))
                        return { ...thirdItem };
                      if (thirdItem.id === 31) {
                        return this.mes.is_hidden || this.mes.turnitin_extend
                          ? { ...thirdItem }
                          : null;
                      }
                      if (thirdItem.id === 32) {
                        return this.mes.is_hidden || this.mes.grammer_extend
                          ? { ...thirdItem }
                          : null;
                      }
                      if (thirdItem.id === 34) {
                        return this.canShowDissertationMenu()
                          ? { ...thirdItem }
                          : null;
                      }
                      if (thirdItem.id === 41 || thirdItem.id === 42) {
                        return this.canShowTranslationMenu()
                          ? { ...thirdItem }
                          : null;
                      }
                      if (thirdItem.id === 14 || thirdItem.id === 24) {
                        //  (id_photo_state == "2" || !this.mes.is_idphoto) &&
                        // this.mes.identity == "在职员工"
                        return { ...thirdItem };
                      }
                      if (
                        thirdItem.id === 5 &&
                        (this.mes.push_extend || this.mes.is_hidden)
                      )
                        return { ...thirdItem };
                      if (
                        thirdItem.id === 6 &&
                        (this.mes.track_extend || this.mes.is_hidden)
                      )
                        return { ...thirdItem };

                      if (organFlag[thirdItem.id]) {
                        const flag = this.organ_product.find(
                          (v) => v.id === organFlag[thirdItem.id]
                        );
                        if (flag) return { ...thirdItem };
                      }

                      return null;
                    })
                    .filter(Boolean);

                  if (filteredThird.length > 0)
                    return { ...subItem, subMenuList: filteredThird };
                }

                return null;
              })
              .filter(Boolean);

            if (filteredSub.length > 0)
              return { ...item, subMenuList: filteredSub };
          }

          return null;
        })
        .filter(Boolean);

      return this.allMenuList.filter((item) => {
        if (
          [3, 4, 5, 6, 7, 8, 9, 10, 14].includes(item.id) &&
          this.disable_group_s.includes(this.mes.belong_id)
        )
          return;
        if ([1, 2, 7, 11, 12, 14].includes(item.id)) return item;
        if (
          item.id === 3 &&
          (this.mes.grammer_extend ||
            this.mes.turnitin_extend ||
            this.mes.is_hidden)
        ) {
          return item;
        }
        if (item.id === 4 && (this.mes.yicai_extend || this.mes.is_hidden)) {
          return item;
        }
        if (item.id === 5 && (this.mes.push_extend || this.mes.is_hidden)) {
          return item;
        }
        if (item.id === 6 && (this.mes.track_extend || this.mes.is_hidden)) {
          return item;
        }
        if (item.id === 8) {
          let flag = this.organ_product.find((v) => v.id === 25);
          if (flag) return item;
        }
        if (item.id === 9) {
          let flag = this.organ_product.find((v) => v.id === 14);
          if (flag) return item;
        }
        if (item.id === 10) {
          let flag = this.organ_product.find((v) => v.id === 1);
          if (flag) return item;
        }
        if (item.id === 13) {
          let flag = this.organ_product.find((v) => v.id === 24);
          if (flag) return item;
        }
      });
    },
    name_system() {
      let industry_s = [
        "编辑部",
        "高校图工委",
        "医图委",
        "学协会",
        "公图",
        "本科学院",
        "本科实验室",
        "本科研究院",
        "医院科室",
        "课题组",
      ];
      if (this.mes.industry && this.mes.industry !== undefined) {
        if (industry_s.indexOf(this.mes.industry) >= 0) {
          return "青梨AI科研服务平台";
        } else {
          return "图书馆AI科研服务平台";
        }
      } else {
        return "青梨AI科研服务平台";
      }
    },
  },
  created() {
    if (sessionStorage.getItem("mes")) {
      this.mes = JSON.parse(sessionStorage.getItem("mes"));
    }
    // console.log('this.mes.phone',this.mes.phone)
    this.message();
    this.$bus.$on("callFunction", this.editMessage);
    // 学术推送 - 机构订阅
    this.ensureSubscribeMenu();
    // console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");

    setTimeout(() => {
      this.unreads();
    }, 1000);
    // console.log("bbbbbbbbbb");
    this.intervalId = setInterval(this.unreads, 30000);
    eventBus.$on("updateNum", this.handleUpdateNum);
    eventBus.$on("newTotal", this.handle_newTotal);
    this.get_permissionUser();
  },
  mounted() {
    // console.log("aaa", this.$route.path);
    if (
      this.$route.path == "/" ||
      this.$route.path == "/single" ||
      this.$route.path == "/booksSet" ||
      this.$route.path == "/xdRegister" ||
      this.$route.path == "/gfRegister"||
      this.$route.path == "/gfEmail"||
      this.$route.path == '/progressOff'
    ) {
      this.orCustomer = false;
    } else {
      this.orCustomer = true;

      this.setInitialPosition();
      window.addEventListener("resize", this.setInitialPosition);
    }
    bus.$on("open-app-dialog", () => {
      console.log("收到事件");
      this.openDialog_Cer();
      // this.dialogVisible = true
    });
    // bus.$on('open-app-dialog', this.openDialog_Cer)
    // console.log(this.orCustomer)
  },
  watch: {
    $route: {
      handler: function (to, from) {
        if (to.name === "Login") {
          return (this.mes = {
            push_extend: true,
            is_hidden: true,
            track_extend: true,
          });
        }
        if (to.name === "home") {
          this.ensureSubscribeMenu();
          if (!this.mes.id_photo_state) {
            return this.message();
          }
        }
        let { fullPath, name } = to;
        console.log(fullPath, name);
        console.log(
          this.firstMenuCurrent,
          typeof this.setCurrentMenuByPath === "function"
        );

        console.log(name, fullPath);
        if (!fullPath) return; // 安全校验，避免 undefined 报错
        console.log(this.firstMenuCurrent);
        let found = false;

        const traverse = (list) => {
          for (let item of list) {
            // 一级菜单匹配
            if (item.name === name) {
              this.firstMenuCurrent = item.id;
              item.expand = true;
            }

            // 匹配路径，支持二级、三级菜单
            if (item.path && fullPath.includes(item.path)) {
              this.subMenuCurrent = item.id;
              found = true;
              return;
            }

            // 遍历子菜单
            if (item.subMenuList && item.subMenuList.length > 0) {
              traverse(item.subMenuList);
              if (found) return;
            }
          }
        };

        traverse(this.allMenuList);

        if (!found) {
          // 如果没找到，则回退到 sessionStorage 或默认值
          const menuCurrent = JSON.parse(sessionStorage.getItem("menuCurrent"));
          if (menuCurrent) {
            this.firstMenuCurrent = menuCurrent.firstMenuCurrent;
            this.subMenuCurrent = menuCurrent.subMenuCurrent;

            const firstMenuItem = this.allMenuList.find(
              (item) => item.id === this.firstMenuCurrent
            );
            if (firstMenuItem && firstMenuItem.subMenuList) {
              firstMenuItem.expand = true;
            }
          } else {
            // 默认回退
            this.firstMenuCurrent = 1;
            this.subMenuCurrent = null;
          }
        }

        // for (let i = 0; i < this.allMenuList.length; i++) {
        //   let item = this.allMenuList[i];
        //   if (item.name === name) {
        //     this.firstMenuCurrent = item.id;
        //     item.expand = true;
        //     if (item.subMenuList) {
        //       for (let j = 0; j < item.subMenuList.length; j++) {
        //         let subItem = item.subMenuList[j];
        //         if (
        //           fullPath === subItem.path ||
        //           fullPath.includes(subItem.path)
        //         ) {
        //           this.subMenuCurrent = subItem.id;
        //           return;
        //         }
        //       }
        //     } else {
        //       this.subMenuCurrent = null;
        //       return;
        //     }
        //   } else {
        //     if (i === this.allMenuList.length - 1) {
        //       let menuCurrent = JSON.parse(
        //         sessionStorage.getItem("menuCurrent")
        //       );
        //       if (menuCurrent) {
        //         this.firstMenuCurrent = menuCurrent.firstMenuCurrent;
        //         this.subMenuCurrent = menuCurrent.subMenuCurrent;
        //         let list = this.allMenuList.find(
        //           (item) => item.id === this.firstMenuCurrent
        //         );
        //         if (list.subMenuList) {
        //           list.expand = true;
        //         }
        //       } else {
        //         this.firstMenuCurrent = 1;
        //         this.subMenuCurrent = null;
        //       }
        //     }
        //   }
        // }
      },
      immediate: true,
    },
    "$route.path"(newPath) {
      console.log(newPath);
      if (
        newPath === "/" ||
        newPath === "/single" ||
        newPath === "/booksSet" ||
        newPath === "/xdRegister" ||
        newPath === "/gfRegister"||
        newPath === "/gfEmail"||
        newPath === '/progressOff'
      ) {
        this.removeScript();
        // this.or_kefu = false
        //  console.log("a");
      } else {
        // this.or_kefu = true
        // this.setInitialPosition();
        // window.addEventListener("resize", this.setInitialPosition);
        //
        this.loadScript();
        //  console.log("b");
      }
    },
  },
  methods: {
    ensureSubscribeMenu() {
      if (localStorage.getItem("subscribeOr") !== "1") {
        return;
      }
      const academicSubMenuList =
        this.allMenuList &&
        this.allMenuList[2] &&
        this.allMenuList[2].subMenuList &&
        this.allMenuList[2].subMenuList[2] &&
        this.allMenuList[2].subMenuList[2].subMenuList;
      if (!Array.isArray(academicSubMenuList)) {
        return;
      }
      const hasSubscribeMenu = academicSubMenuList.some(
        (item) => item && item.id === 53
      );
      if (hasSubscribeMenu) {
        return;
      }
      academicSubMenuList.splice(2, 0, {
        id: 53,
        title: "机构订阅",
        path: "/academic?webPage=4",
        parentId: 5,
      });
    },
    openDialog_Cer() {
      // this.showCer = true;
      if (this.mes.improve_rewards == "1") {
        this.showCer = true;
      }
    },
    canShowDissertationMenu() {
      return !!(
        this.mes.is_hidden ||
        this.mes.grammer_extend ||
        this.mes.turnitin_extend
      );
    },
    filterDissertationSubMenu(subMenuList) {
      return subMenuList.filter((item) => {
        if (item.id === 31) {
          return this.mes.is_hidden || this.mes.turnitin_extend;
        }
        if (item.id === 32) {
          return this.mes.is_hidden || this.mes.grammer_extend;
        }
        if (item.id === 34) {
          return this.canShowDissertationMenu();
        }
        return true;
      });
    },
    canShowTranslationMenu() {
      return !!(this.mes.is_hidden || this.mes.yicai_extend);
    },
    filterTranslationSubMenu(subMenuList) {
      return subMenuList.filter(() => this.canShowTranslationMenu());
    },
    get_permissionUser() {
      if (localStorage.getItem("token")) {
        permissionUser()
          .then((res) => {
            console.log(res);
            const order = [
              // "book_num",
              // "total_num",
              "grammer_extend",
              "turnitin_extend",
              "yicai",
            ];
            const userTrial = res.data.data.user_trial;
            const user_trial_array = order
              .filter((key) => key in userTrial) // 仅取 userTrial 中存在的字段
              .map((key) => ({
                key,
                value: userTrial[key],
              }));
            console.log(user_trial_array);
            this.user_formal = res.data.data.user_formal;
            this.user_trial = res.data.data.user_trial;
            this.user_trial_array = user_trial_array;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    findMenuTitleById(menuList, targetId) {
      for (const item of menuList) {
        if (item.id === targetId) {
          return item.title;
        }
        if (item.subMenuList && item.subMenuList.length > 0) {
          const found = this.findMenuTitleById(item.subMenuList, targetId);
          if (found) return found;
        }
      }
      return null;
    },
    get_xn_user_aes(unionid_) {
      xnUseraAes({
        unionid: unionid_,
      })
        .then((res) => {
          console.log(res);
          if (res.data.error_code == 0) {
            sessionStorage.setItem(
              "xn_user_aes",
              JSON.stringify(res.data.data)
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleUpdateNum(num) {
      const normalized = Number(num) > 0 ? Number(num) : 0;
      this.num_total = normalized;
      this._lastEventBusNum = normalized;
      this._lastEventBusNumAt = Date.now();
    },
    handle_newTotal(num) {
      this.num_msg_total = num;
    },
    refreshData() {
      this.unreads(); // 获取当前时间并更新
    },
    stopRefreshing() {
      clearInterval(this.intervalId); // 停止定时器
      this.intervalId = null; // 清空定时器ID
    },
    unreads() {
      // console.log(this.$route.path);
      if (
        this.$route.path == "/" ||
        this.$route.path == "/single" ||
        this.$route.path == "/booksSet" ||
        this.$route.path == "/xdRegister" ||
        this.$route.path == "/gfRegister"||
        this.$route.path == "/gfEmail"||
        this.$route.path == '/progressOff'
      ) {
        return;
      }
      newUnreadNumber()
        .then((res) => {
          let apiNum = Number(res.data.data.num);
          if (isNaN(apiNum)) apiNum = 0;
          const normalized = apiNum > 0 ? apiNum : 0;
          if (
            this._lastEventBusNumAt &&
            Date.now() - this._lastEventBusNumAt < 3000 &&
            normalized > this._lastEventBusNum
          ) {
            return;
          }
          this.num_total = normalized;
        })
        .catch((err) => {
          console.log(err);
        });

      extend_readNumber()
        .then((res) => {
          console.log(res);
          if (res.data.data.grammer > 0 || res.data.data.turnitin > 0) {
            this.grammerNum = res.data.data.grammer;
            this.turnitinNum = res.data.data.turnitin;
            // console.log(this.num_total);
          } else {
            this.grammerNum = 0;
            this.turnitinNum = 0;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      cat_unreadNumber()
        .then((res) => {
          // console.log(res);
          if (res.data.data > 0) {
            this.translateNum = res.data.data;
            // console.log(this.num_total);
          } else {
            this.translateNum = 0;
          }
        })
        .catch((err) => {
          console.log(err);
        });

      fetchMessage({
        page: 1,
        size: 10,
        isread: "1",
      })
        .then((res) => {
          console.log(res);

          this.num_msg_total = res.data.data.count;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 退出登录
    loginOut() {
      // console.log('退出')
      // return
      this.logoutDisabled = true;
      this.$confirm("确认退出账号？")
        .then((_) => {
          this.logoutDisabled = false;
          // console.log(this.mes)
          if (this.mes.sing_on) {
            this.$router.push({
              path: `/single?orgCode=${this.mes.org_code}`,
              // query: { orgCode: this.mes.organ_code },
            });
          } else {
            this.$router.push({
              name: "Login",
              // query: { key: Date.now() },
            });
          }
          localStorage.clear();
          sessionStorage.clear();
          this.removeScript();
          // console.log(this.mes)
          return;

          // window.location.reload();
        })
        .catch((_) => {
          setTimeout(() => {
            this.logoutDisabled = false;
          }, 500);
        });
    },
    hasId(list, targetId) {
      for (let item of list) {
        if (item.id === targetId) return true; // 找到
        // 如果有子菜单，递归判断
        if (item.subMenuList && item.subMenuList.length > 0) {
          if (hasId(item.subMenuList, targetId)) return true;
        }
      }
      return false; // 遍历完没找到
    },
    // 一级菜单切换
    async firstMenuChange(item, index) {
      console.log(item, index);
      if (item.id === 7) {
        return this.$message({
          message: "极速升级，即将呈现，敬请期待！",
          type: "warning",
        });
      }
      if (item.subMenuList) {
        // 一级菜单展开
        // Academic
        if (item.name && item.name === "Academic") {
          if (this.mes.push_extend == false) {
            this.$message({
              message:
                "暂无该功能的使用权限，快去联系所属机构负责人进行开通体验吧！",
              type: "info",
            });
          } else {
            let open_code = {
              open_id: localStorage.getItem("code"),
              organ_name: localStorage.getItem("org_ode"),
            };
            organinfo(open_code)
              .then((res) => {
                localStorage.setItem("organ_info", res.data.data);
                item.expand = !item.expand;
              })
              .catch((err) => {
                console.log(err);
              });
          }
        } else if (item.name && item.name === "Citation") {
          if (this.mes.track_extend) {
            let user_citation = {
              user_openid: localStorage.getItem("code"),
              institution_name: localStorage.getItem("org_name"),
            };
            const res = await getUser(user_citation);
            if (res.data.have_user !== 1) {
              this.openDialog(index);
            } else {
              let openCode = {
                user_openid: localStorage.getItem("code"),
              };
              judge_user(openCode)
                .then((res) => {
                  if (res.data.user_mes.length > 0) {
                    localStorage.setItem(
                      "en_name",
                      res.data.user_mes[0].en_user_name
                    );
                    item.expand = !item.expand;
                  } else {
                    this.openDialog(index);
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          } else {
            this.$message({
              message:
                "暂无该功能的使用权限，快去联系所属机构负责人进行开通体验吧！",
              type: "info",
            });
          }
        } else {
          item.expand = !item.expand;
        }
      } else if (item.type === "external") {
        // 外部链接跳转
        let id_photo_state = sessionStorage.getItem("id_photo_state")
          ? sessionStorage.getItem("id_photo_state")
          : "2";
        let unionid = sessionStorage.getItem("unionid");
        let org_ode = localStorage.getItem("org_ode");
        if (id_photo_state == "2" || !this.mes.is_idphoto) {
          let url = "";
          if (item.name === "Chat选刊") {
            // source=${"xuanNiao"}&token=${token}&loginType=2
            url =
              item.path +
              "?loginType=2&token=" +
              localStorage.getItem("token") +
              "&source=ql";
          } else if (item.name === "chatresearch") {
            url =
              this.getChatResearchBaseUrl() +
              "?loginTypeName=ql&token=" +
              localStorage.getItem("token") +
              "&scene=miniprogram";
          } else {
            url = item.path + "?type=ql";
            if (item.name === "knowledge") {
              url =
                url +
                "&user_id=" +
                unionid +
                "&organ_code=" +
                org_ode +
                "&source=ql";
            } else if (item.name === "wdl") {
              url =
                url +
                "&source=ql&user_id=" +
                unionid +
                "&organ_code=" +
                org_ode;
            } else if (item.name === "journal") {
              url =
                url +
                "&source=ql&user_id=" +
                unionid +
                "&organ_code=" +
                org_ode;
            } else if (item.name === "mscholar") {
              url =
                url +
                "&source=ql&user_id=" +
                unionid +
                "&organ_code=" +
                org_ode;
            }
          }

          // console.log(url)
          // return
          window.open(url, "_blank");
        } else {
          this.open_confirm();
        }
      } else {
        // 二级目录
        if (item.id === this.firstMenuCurrent) return;
        this.firstMenuCurrent = item.id;
        this.subMenuCurrent = null;
        sessionStorage.setItem(
          "menuCurrent",
          JSON.stringify({
            firstMenuCurrent: this.firstMenuCurrent,
            subMenuCurrent: this.subMenuCurrent,
          })
        );
        this.$router.push({ path: item.path });
      }
    },
    open_confirm() {
      this.$confirm(
        "该功能需进行身份验证，请前往微信小程序完善您的证件信息。感谢您的配合与理解！",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          showCancelButton: false,
          // showConfirmButton: false,
        }
      )
        .then(() => {})
        .catch(() => {});
    },
    handleSubMenuClick(command) {
      // command 就是你在 :command 里传的对象
      console.log("父级菜单:", command.parent);
      console.log("子级菜单:", command.child);

      // 你可以保存
      this.subMenuChange(command.child);
    },
    // 二级菜单切换
    subMenuChange(subItem) {
      console.log(subItem);
      if (subItem.id == 22 || subItem.id == 7) {
        return this.$message.warning("极速升级，即将呈现，敬请期待！");
      } else if (subItem.type === "external") {
        // 外部链接跳转
        let item = subItem;
        let id_photo_state = sessionStorage.getItem("id_photo_state")
          ? sessionStorage.getItem("id_photo_state")
          : "2";
        let unionid = sessionStorage.getItem("unionid");
        let org_ode = localStorage.getItem("org_ode");
        if (id_photo_state == "2" || !this.mes.is_idphoto) {
          let url = "";
          if (item.name === "Chat选刊") {
            // source=${"xuanNiao"}&token=${token}&loginType=2
            url =
              item.path +
              "?loginType=2&token=" +
              localStorage.getItem("token") +
              "&source=ql";
          } else if (item.name === "chatresearch") {
            url =
              this.getChatResearchBaseUrl() +
              "?loginTypeName=ql&token=" +
              localStorage.getItem("token") +
              "&scene=miniprogram";
          } else {
            if (item.id_product != null) {
              const organProducts =
                (this.mes && this.mes.organ_product) ||
                this.organ_product ||
                [];
              const matchedProduct = organProducts.find(
                (p) => p.id === item.id_product
              );
              if (matchedProduct && matchedProduct.is_expired) {
                this.dialogProductExpired = true;
                return;
              }
            }
            url = item.path + "?type=ql";
            if (item.name === "knowledge") {
              url =
                url +
                "&user_id=" +
                unionid +
                "&organ_code=" +
                org_ode +
                "&source=ql";
            } else if (item.name === "wdl") {
              url =
                item.path +
                "?source=ql&user_id=" +
                unionid +
                "&organ_code=" +
                org_ode;
              // url =
              //   'https://dissertation.newacademic.net/#/?' +
              //   "source=ql&user_id=" +
              //   unionid +
              //   "&organ_code=" +
              //   org_ode;
              //  url =
              //   'https://dissertation.newacademic.net/#/?' +
              //   "token=" +
              //   localStorage.getItem("token") +
              //   "&tituName=" +
              //   localStorage.getItem("org_name");
            } else if (item.name === "journal") {
              url =
                url +
                "&source=ql&user_id=" +
                unionid +
                "&organ_code=" +
                org_ode;
            } else if (item.name === "mscholar") {
              url =
                url +
                "&source=ql&user_id=" +
                unionid +
                "&organ_code=" +
                org_ode;
            }
          }

          console.log(url);
          window.open(url, "_blank");
        } else {
          this.open_confirm();
        }
      } else if (subItem.title == "机构订阅" && this.mes.id_photo_state !== 2) {
        this.open_confirm();
        return;
      } else if (!subItem.path) {
        return;
      } else if (subItem.id === this.subMenuCurrent) {
        return;
      } else {
        this.subMenuCurrent = subItem.id;
        this.firstMenuCurrent = subItem.parentId;
        sessionStorage.setItem(
          "menuCurrent",
          JSON.stringify({
            firstMenuCurrent: this.firstMenuCurrent,
            subMenuCurrent: this.subMenuCurrent,
          })
        );
        this.$router.push({ path: subItem.path });
      }
    },
    message() {
      // console.log('https://kefu.newacademic.net')
      if (localStorage.getItem("token")) {
        personalMessage()
          .then((res) => {
            sessionStorage.setItem("mes", JSON.stringify(res.data.data));
            if (!sessionStorage.getItem("xn_user_aes")) {
              this.get_xn_user_aes(res.data.data.unionid);
            }
            this.mes = res.data.data;
            this.name = res.data.data.name;
            this.email = res.data.data.email;
            this.phone = res.data.data.phone;
            if (res.data.data.is_xuanniao_user) {
              this.xn_show = res.data.data.is_xuanniao_user;
            }
            if (
              res.data.data.sing_on &&
              res.data.data.is_perfect &&
              sessionStorage.getItem("user_info_or")
            ) {
              this.remainderDay = this.mes.days_remaining;

              this.userForm = {
                user_id: this.mes.user_id,
                organ_code: this.mes.org_code,
                // name: this.name,
                // faculty: this.mes.faculty,
                // phone: this.mes.phone,
                // email: this.mes.email,
                // jobNumber: this.mes.jobNumber,
                name: this.mes.name == this.mes.code ? "" : this.mes.name,
                faculty:
                  this.mes.faculty == this.mes.code ? "" : this.mes.faculty,
                // phone: "",
                email: this.mes.email == this.mes.code ? "" : this.mes.email,
                jobNumber:
                  this.mes.jobNumber == this.mes.code ? "" : this.mes.jobNumber,
                // phone_code: "",
                // email_code: "",
              };
              this.userForm_copy = {
                user_id: this.mes.user_id,
                organ_code: this.mes.org_code,
                name: this.mes.name == this.mes.code ? "" : this.mes.name,
                faculty:
                  this.mes.faculty == this.mes.code ? "" : this.mes.faculty,
                email: this.mes.email == this.mes.code ? "" : this.mes.email,
                jobNumber:
                  this.mes.jobNumber == this.mes.code ? "" : this.mes.jobNumber,
                // email_code: "",
              };
              this.trimUserNameFacultyFields();
              // console.log("this.mes", this.userForm_copy);
              this.getFaculty(this.mes.organ_id, this.mes.faculty);
              this.dialogUserInfo = true;
            }
            // console.log("this.$route", this.$route);
            if (
              this.$route.path == "/personal" &&
              this.$route.query.webPage &&
              this.$route.query.webPage == 1
            ) {
              this.reloads();
            }
            if (
              this.$route.path !== "/" &&
              this.$route.path !== "/single" &&
              this.$route.path !== "/booksSet" &&
              this.$route.path !== "/xdRegister" &&
              this.$route.path !== "/gfRegister" &&
              this.$route.path !== "/gfEmail"
              &&
              this.$route.path !== '/progressOff'
            ) {
              this.loadScript();
            }
            sessionStorage.setItem(
              "id_photo_state",
              res.data.data.id_photo_state
            );
            sessionStorage.setItem("headshot", res.data.data.avatarUrl);
            sessionStorage.setItem("unionid", res.data.data.unionid);
            localStorage.setItem(
              "organ_product",
              JSON.stringify(res.data.data.organ_product)
            );
            this.organ_product = res.data.data.organ_product || [];
            localStorage.setItem("code", res.data.data.code);
            localStorage.setItem(
              "selected_journals",
              res.data.data.selected_journals
            );
            // localStorage.setItem("email", res.data.data.email);
            localStorage.setItem("org_ode", res.data.data.org_code);
            localStorage.setItem("org_name", res.data.data.org_name);
            localStorage.setItem(
              "attestation_state",
              res.data.data.attestation_state
            );
            // res.data.data.attestation_state = 7;
            //  this.gpsshow = true;
            if (
              res.data.data.attestation_state == 3 ||
              res.data.data.attestation_state == 2||
              res.data.data.is_before_july31_gps_auth
            ) {
              this.gpsshow = true;
              this.gps_remainder = res.data.data.gps_remainder;
              this.gps_term = res.data.data.gps_term;
              if (res.data.data.attestation_state == 3) {
                this.is_close = false;
              } else {
                this.is_close = true;
              }
              if (res.data.data.sing_on && res.data.data.is_bind_wx) {
                this.sing_on_or = true;
                this.userForm.user_id = res.data.data.user_id;
                this.userForm.organ_code = res.data.data.org_code;
                // this.getYard_img({
                //   user_id: res.data.data.user_id,
                //   organ_code: res.data.data.org_code,
                // });
              }
            } else if (res.data.data.attestation_state == 7) {
              this.showInfo = true;
            }
            if (res.data.data.writful_extend) {
              localStorage.setItem("writful_permissions", 1);
            }
          })
          .catch((err) => {
            console.log(err);
          });

        fetchMessage()
          .then((res) => {
            // console.log(res);
            let record = 0;
            if (res.data.data.length > 0) {
              res.data.data.forEach((item) => {
                if (item.record_id == null) {
                  ++record;
                }
              });
            }
            // console.log(record)
            if (record > 0) {
              this.total = record;
            }

            this.$emit("getTreeData", record);
            // this.$emit("newTotal", record);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    /** 去除首尾空白；非字符串原样返回（便于 select 等） */
    trimText(val) {
      if (val == null) return "";
      if (typeof val !== "string") return val;
      return val.trim();
    },
    /** 规范化姓名、院系、自定义院系字段，避免仅空白字符被当作已填写 */
    trimUserNameFacultyFields() {
      this.userForm.name = this.trimText(this.userForm.name);
      this.userForm.faculty = this.trimText(this.userForm.faculty);
      this.userForm_copy.name = this.trimText(this.userForm_copy.name);
      this.userForm_copy.faculty = this.trimText(this.userForm_copy.faculty);
      this.other_faculty = this.trimText(this.other_faculty);
    },
    getChatResearchBaseUrl() {
      const loc = window.location.href;
      const isTestEnv =
        loc.includes("ql-test.") || loc.includes("168.66.34");
      return isTestEnv
        ? "https://testchatresearch.newacademic.net/"
        : "https://chatresearch.newacademic.net/";
    },
    editMessage(data) {
      console.log(data);

      if (data.sing_on && data.is_perfect) {
        this.remainderDay = data.days_remaining;
        this.userForm = {
          user_id: data.user_id,
          organ_code: data.org_code,
          // name: data.name,
          // faculty: data.faculty,
          // phone: data.phone,
          // email: data.email,
          // jobNumber: data.jobNumber,
          // phone_code: "",

          name: this.mes.name == this.mes.code ? "" : this.mes.name,
          faculty: this.mes.faculty == this.mes.code ? "" : this.mes.faculty,
          // phone: "",
          email: this.mes.email == this.mes.code ? "" : this.mes.email,
          jobNumber:
            this.mes.jobNumber == this.mes.code ? "" : this.mes.jobNumber,
          // phone_code: "",
          // email_code: "",
        };
        this.userForm_copy = {
          user_id: data.user_id,
          organ_code: data.org_code,
          name: this.mes.name == this.mes.code ? "" : this.mes.name,
          faculty: this.mes.faculty == this.mes.code ? "" : this.mes.faculty,
          email: this.mes.email == this.mes.code ? "" : this.mes.email,
          jobNumber:
            this.mes.jobNumber == this.mes.code ? "" : this.mes.jobNumber,
          // email_code: "",
        };
        this.trimUserNameFacultyFields();
        // console.log(data);
        // console.log('this.mes', this.userForm_copy.name);
        // if(this.userForm_copy.name){
        //   console.log('有值')
        // }else{
        //   console.log('无值')
        // }
        this.getFaculty(data.organ_id, data.faculty);
        this.dialogUserInfo = true;
      } else if (data.sing_on) {
        // this.dialogPrompt = true;
        this.userForm.user_id = data.user_id;
        this.userForm.organ_code = data.org_code;
        // console.log( this.userForm)
        this.getYard();
      }
    },
    getFaculty(id, idFaculty) {
      console.log(id);
      serachDepartment({
        org_id: id,
        con: "",
      })
        .then((res) => {
          console.log(res);
          this.facultyArry = res.data.data.organ_name_list;
          const matchingObjects = this.facultyArry.filter(
            (item) => item === idFaculty
          );

          // this.facultyArry.push("其他");

          if (!res.data.data.is_customize) {
            this.facultyArry.push("自定义");
          }
          const facultyTrim = this.trimText(this.userForm.faculty);
          if (
            matchingObjects.length <= 0 &&
            facultyTrim &&
            facultyTrim !== this.mes.code
          ) {
            this.other_faculty = facultyTrim;
            // this.userForm.faculty = "其他";
            this.userForm.faculty = "自定义";
          } else {
            this.userForm.faculty = "";
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getEmail() {
      emailRegister({
        new_email: this.userForm.email,
      })
        .then((res) => {
          console.log(res);
          if (res.data.error_code == 0) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.stopCountdown();
        });
    },
    getPhone() {
      phoneRegister({
        new_email: this.userForm.email,
      })
        .then((res) => {
          console.log(res);
          if (res.data.error_code == 0) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.stopCountdown();
        });
    },
    getCode() {
      if (!this.userForm.email) {
        this.$message.error("请输入邮箱！");
        return;
      }
      if (this.isCountingDown) {
        return;
      }

      // 启动倒计时
      this.startCountdown();
      // this.getPhone();
      this.getEmail();
    },
    subInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.userForm);
          // return;
          let userForm_copy = JSON.parse(JSON.stringify(this.userForm));
          userForm_copy.name = this.trimText(userForm_copy.name);
          userForm_copy.faculty = this.trimText(userForm_copy.faculty);
          const otherFacultyTrim = this.trimText(this.other_faculty);
          if (userForm_copy.faculty === "自定义") {
            // if (userForm_copy.faculty == "其他") {
            if (!otherFacultyTrim) {
              return this.$message({
                message: "请输入院系/部门！",
                type: "warning",
              });
            } else {
              userForm_copy.faculty = otherFacultyTrim;
            }
          }
          // if(this.mes.real_phone){
          //   userForm_copy.phone = this.mes.real_phone
          // }

          userComplete(userForm_copy)
            .then((res) => {
              console.log(res);
              if (res.data.error_code == 0) {
                this.dialogUserInfo = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                sessionStorage.removeItem("user_info_or");
                this.dialogUserInfo = false;
                this.dialogPrompt = true;
                this.message();
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    go_Bind() {
      this.getYard();
      this.loadingBind = true;
      // this.dialogPrompt = false;
      //
    },
    startTimers() {
      this.intervalTimer = setInterval(() => {
        this.message_bind();
      }, 5 * 1000);
    },
    message_bind() {
      if (localStorage.getItem("token")) {
        personalMessage()
          .then((res) => {
            console.log(res);
            if (res.data.data && !res.data.data.is_bind_wx) {
              this.$message({
                message: "微信绑定成功",
                type: "success",
              });
              this.sing_on_or = false;
              this.stopTimersManually();
              this.downShutBind();
              this.message();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    stopTimersManually() {
      if (this.intervalTimer) {
        clearInterval(this.intervalTimer);
        this.intervalTimer = null;
      }
    },
    downShutBind() {
      this.dialogUserGarden = false;
      this.stopTimersManually();
    },
    getYard_img(obj) {
      this.bindImg = "";

      appletWx(obj)
        .then((res) => {
          console.log(res);
          // this.loadingBind = false;
          if (res.data.error_code == 0) {
            this.bindImg = res.data.data;
            this.startTimers();
          }
          //
        })
        .catch((err) => {
          console.log(err);
          this.loadingBind = false;
        });
    },
    getYard() {
      this.dialogPrompt = false;
      this.dialogUserGarden = true;
      this.bindImg = "";
      console.log(this.userForm.organ_code);
      appletWx({
        user_id: this.userForm.user_id,
        organ_code: this.userForm.organ_code,
      })
        .then((res) => {
          console.log(res);
          this.loadingBind = false;
          if (res.data.error_code == 0) {
            this.bindImg = res.data.data;
            // const base64Data = res.data.data;
            // const correctedBase64 = base64Data.replace(
            //   /(data:image\/\w+;base64,)+/,
            //   "data:image/jpg;base64,"
            // );
            // this.bindImg = correctedBase64;

            this.startTimers();
          }
          //
        })
        .catch((err) => {
          console.log(err);
          this.loadingBind = false;
        });
    },
    refineLater() {
      this.dialogUserInfo = false;
      sessionStorage.removeItem("user_info_or");
    },
    // 启动倒计时
    startCountdown() {
      this.isCountingDown = true;
      this.countdown = 60; // 初始化倒计时
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown -= 1; // 每秒减少1
        } else {
          this.stopCountdown(); // 倒计时结束
        }
      }, 1000);
    },
    // 停止倒计时
    stopCountdown() {
      this.isCountingDown = false;
      clearInterval(this.countdownTimer);
      this.countdownTimer = null; // 清空定时器引用
    },
    // 引文追踪
    openDialog(index) {
      let chinese_name = {
        keyword: localStorage.getItem("name"),
      };
      this.openIndex = index;
      organ_association(chinese_name)
        .then((res) => {
          this.enName = res.data.data;
          this.form = {
            name: localStorage.getItem("name"),
            en_name: res.data.data,
            code: localStorage.getItem("org_name"),
          };
          this.dialogFormVisible = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    enroll() {
      let register_data = {
        ch_user_name: localStorage.getItem("name"),
        en_user_name: this.enName,
        institution_name: localStorage.getItem("org_name"),
        user_openid: localStorage.getItem("code"),
        institution_code: localStorage.getItem("org_ode"),
      };
      confirmUser(register_data)
        .then((res) => {
          let openCode = {
            user_openid: localStorage.getItem("code"),
          };
          judge_user(openCode)
            .then((res) => {
              localStorage.setItem(
                "en_name",
                res.data.user_mes[0].en_user_name
              );
              this.allMenuList[this.openIndex].expand = true;
              this.dialogFormVisible = false;
              this.openIndex = null;
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 外链跳转无权限提示
    open_confirm() {
      this.$confirm(
        "该功能需进行身份验证，请前往微信小程序完善您的证件信息。感谢您的配合与理解！",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          showCancelButton: false,
          // showConfirmButton: false,
        }
      )
        .then(() => {})
        .catch(() => {});
    },

    reloads() {
      this.isRouterAlives = false;
      this.$nextTick(function () {
        this.isRouterAlives = true;
      });
    },
    openCustomer() {
      // console.log("aaaaa");
      if (!this.isDragging) {
        window.open(
          "https://work.weixin.qq.com/kfid/kfc7331c393135989a8",
          "_blank"
        );
      }
    },
    setInitialPosition() {
      const notification = this.$refs.notification;
      if (notification) {
        const { innerWidth, innerHeight } = window;
        const { offsetWidth, offsetHeight } = notification;
        this.posX = innerWidth - offsetWidth - 30; // 距离右侧30px
        this.posY = innerHeight - offsetHeight - 50; // 距离底部20px
      }
    },
    startDrag(event) {
      if (event.button !== 0) return; // 仅响应鼠标左键

      this.isDragging = false;
      this.dragStartTime = Date.now();

      this.offsetX = event.clientX - this.posX;
      this.offsetY = event.clientY - this.posY;

      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
    },
    onDrag(event) {
      const dx = event.clientX - (this.posX + this.offsetX);
      const dy = event.clientY - (this.posY + this.offsetY);

      if (!this.isDragging && Math.sqrt(dx * dx + dy * dy) > 5) {
        this.isDragging = true;
        this.$refs.notification.style.pointerEvents = "none";
      }

      if (this.isDragging) {
        this.posX = event.clientX - this.offsetX;
        this.posY = event.clientY - this.offsetY;

        // let newX = event.clientX - this.offsetX;
        // let newY = event.clientY - this.offsetY;
        // const el = this.$refs.notification;
        // const elWidth = el.offsetWidth;
        // const elHeight = el.offsetHeight;

        // // 限制 X 轴边界
        // newX = Math.max(0, Math.min(window.innerWidth - elWidth, newX));
        // // 限制 Y 轴边界
        // newY = Math.max(0, Math.min(window.innerHeight - elHeight, newY));

        // // 设置最终位置
        // this.posX = newX;
        // this.posY = newY;
      }
    },
    stopDrag() {
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);

      this.$refs.notification.style.pointerEvents = "";

      const dragDuration = Date.now() - this.dragStartTime;
      if (!this.isDragging || dragDuration < 200) {
        // this.openCustomer();
      }

      this.isDragging = false;
    },
    onMouseLeave() {
      // 只有在非拖拽状态下，才关闭
      if (!this.isDragging) {
        this.isExpanded = false;
      }
    },
    offCustomer() {
      this.orCustomer = false;
      return;
    },
    loadScript() {
      // console.log('aaaaa')
      this.or_kefu = true;
      this.orCustomer = true;
      this.setInitialPosition();
      window.addEventListener("resize", this.setInitialPosition);

      // if (this.showScript) {
      //   return;
      // }
      // let that = this;
      // const script = document.createElement("script");
      // script.id = "michat-script";
      // script.src =
      //   "https://chatlibrary.newacademic.net/static/customerServer.js";

      // script.onload = () => {
      //   const option = {
      //     authInit: true,
      //     openUrl: "https://kefu.newacademic.net",
      //     token: "d91374b1ceb161387d860ede470b230e",
      //     kefuid: "", // 默认为空自动对接客服，可填写指定客服ID
      //     isShowTip: true, // 初始化成功后，界面右下角会自动创建 “联系客服按钮”
      //     mobileIcon:
      //       "https://chatlibrary.newacademic.net/static/QQ20241120-155727.png", // 手机端悬浮客服图片
      //     pcIcon:
      //       "https://chatlibrary.newacademic.net/static/QQ20241120-155727.png", // PC端悬浮客服图片
      //     // windowStyle: "center", // center 普通中间弹窗样式
      //     sendUserData: {
      //       uid: that.mes.user_id, // 用户id
      //       nickName: that.mes.nickName, // 用户昵称
      //       phone: that.mes.phone, // 用户联系方式
      //       sex: "1", // 用户性别
      //       avatar: that.mes.avatarUrl, // 用户头像 URL地址
      //       openid: that.mes.unionid, //微信openid
      //     },
      //   };
      //   const canCustomerServer = new initCustomerServer(option);
      //   canCustomerServer.init();
      // };
      // script.onerror = () => {
      //   console.error("客服脚本加载失败！");
      // };
      // document.head.appendChild(script);
      // this.showScript = true;
      // // setTimeout(() => {
      // //   this.toggleDisplay(true);
      // // }, 100)
    },
    removeScript() {
      this.or_kefu = false;
      this.orCustomer = false;
      const script = document.getElementById("michat-script");
      console.log(script);
      if (script) {
        script.remove(); // 删除脚本
        setTimeout(() => {
          const michatStyles = document.querySelectorAll(
            'style[id*="mivisit"]'
          );
          const michatElements = document.querySelectorAll(
            "#MICHAT-INVITE-WRAP, .michat-custom-class"
          );
          // console.log("Styles to remove: ", michatStyles);
          // console.log("Elements to remove: ", michatElements);
          michatStyles.forEach((style) => style.remove());
          michatElements.forEach((el) => el.remove());
          this.showScript = false;
          window.location.reload();
        }, 100);
      }
    },
    toggleDisplay(isVisible) {
      const michatWrap = document.getElementById("MICHAT-INVITE-WRAP");
      console.log(michatWrap);
      if (michatWrap) {
        michatWrap.style.display = isVisible ? "block" : "none";
        this.reloads();
      } else {
      }
    },

    go_xuanniao() {
      let url = "https://xuanniao.newacademic.net/";
      // let url = "http://192.168.66.34:5173/";
      if (sessionStorage.getItem("xn_user_aes")) {
        url =
          url +
          `?iv=${encodeURIComponent(sessionStorage.getItem("xn_user_aes"))}`;
      }
      window.open(url, "_blank");
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setInitialPosition);
    bus.$off("open-app-dialog", this.openDialog_Cer);
  },
};
</script>
<style lang="less">
::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.el-aside {
  width: 260px !important;
  height: 100vh;
  background: #ffffff;
  border-right: 1px solid #E1E1E2;
  .system {
    height: 80px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 4px;
    padding: 0 24px;
    box-sizing: border-box;

    .organName {
      font-size: 24px;
      color: #000;
      font-style: initial;
      font-family: DingTalk-JinBuTi;

      overflow: hidden;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }

    .systemName {
      font-size: 14px;
      color: #e2426b;
      font-style: initial;
      font-family: DingTalk-JinBuTi;
    }
  }

  .logo_area {
    position: fixed;
    width: 252px;
    // left: 24px;
    bottom: 15px;
    // border-radius: 10px;
    display: flex;
    justify-content: center;
    img {
      width: 80%;
    }
  }

  .menuBox {
    padding: 24px 24px 0 24px;
    box-sizing: border-box;
    // cursor: pointer;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 160px);
    overflow-y: auto;
    gap: 8px;

    .itemBox {
      display: flex;
      flex-direction: column;
      gap: 8px;
      color: #6b6e73;
      font-size: 14px;
      font-weight: 500;

      .el-divider {
        margin: 4px 0;
      }

      .firstMenu:hover {
        // background-color: #ffe9ef;
      }

      .firstMenu_active {
        // background-color: #ffe9ef;
        color: #e2426b;
      }

      .firstMenu {
        height: 44px;
        line-height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        border-radius: 8px;

        .leftBox {
          display: flex;
          align-items: center;
          gap: 8px;

          .icon {
            width: 20px;
            height: 20px;
            vertical-align: middle;
          }
        }
      }

      .subMenu {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .subItemBox:hover {
          // border: 1px solid #e2426b;
          background-color: #ffe9ef;
        }

        .subMenu_active {
          color: #d25471;
          border: 1px solid #f9d9e1 !important;
          background-color: #f9d9e1 !important;
        }

        .subItemBox {
          display: flex;
          align-items: center;
          gap: 8px;
          padding-left: 36px;
          box-sizing: border-box;
          border-radius: 8px;
          height: 42px;
          line-height: 42px;

          .circle {
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background-color: #6b6e73;
            display: inline-block;
          }

          .circle_active {
            background-color: #e2426b;
          }
        }
      }
    }

    .el-menu {
      border: none;
      display: flex;
      flex-direction: column;
      gap: 4px;

      .el-menu-item:hover,
      .el-submenu__title:hover {
        background-color: #ffe9ef;
      }

      /deep/ .el-submenu {
        border-radius: 8px;
      }

      .el-menu-item,
      .el-submenu__title {
        height: 44px;
        line-height: 44px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        border-radius: 8px;
        gap: 8px;

        .icon {
          width: 24px;
          height: 24px;
          vertical-align: middle;
        }

        span {
          line-height: 1px;
        }

        .circle {
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: #6b6e73;
        }

        .active {
          background-color: #e2426b;
        }
      }

      .menuActive {
        background-color: #ffe9ef;
      }

      .subMenuActive {
        border: 1px solid #e2426b;
        background-color: #fff;
      }
    }
  }
}

.el-header {
  padding: 0 24px !important;
  line-height: 80px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .modelName {
    font-size: 18px;
    font-weight: 500;
    color: #000;
    font-family: "PingFang SC";
  }

  .userInfo {
    width: max-content;

    .el-divider {
      margin: 8px 0;
    }

    .content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 30px;
      gap: 12px;
      .user {
        display: flex;
        align-items: center;
        gap: 8px;
        .mobile_css {
          // display: flex;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
        }
        .mobile {
          font-size: 16px;
          font-weight: 700;
          height: 22px;
          line-height: 22px;
          // display: block;
        }

        .el-tag {
          color: #262729;
          font-size: 10px;
        }
      }

      .icon {
        width: 24px;
        height: 24px;
        // margin-left: 8px;
        cursor: pointer;
      }
    }

    .hint {
      margin-top: 8px;
      font-size: 12px;
      color: #a8aaae;
      line-height: 16px;
    }
  }

  img {
    vertical-align: middle;
  }
}

.tit_message {
  line-height: 1.5;
  margin-bottom: 20px;
}
.el-badge__content.is-fixed {
  top: 0px !important;
}
.get_code_css {
  width: 90px;
  height: 30px;
  line-height: 23px;
  border-radius: 4px;
  background-color: rgba(226, 66, 107, 0.1);
  color: rgba(226, 66, 107, 1);
  font-size: 13px;
  text-align: center;
  font-family: PingFangSC-regular;
  padding: 3px 12px;
  cursor: pointer;
}

.userInfo_css {
  border-radius: 8px !important;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 30px 30px;
  }
  .tit_dialog {
    font-weight: 600;
    color: #e2426b;
    font-size: 25px;
  }
  .tit_fill {
    font-weight: 600;
    color: #000000;
    font-size: 23px;
    line-height: 60px;
  }
  .tit_p {
    line-height: 20px;
    color: #9a9a9a;
  }
  .el-input__suffix {
    display: flex;
    align-items: center;
  }
  .el-form-item__label {
    // text-align: left;
  }
  .user_dialog_footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .bottom_p {
    text-align: center;
    line-height: 30px;
    margin: 10px 0 0 0;
    color: #9a9a9a;
    span {
      color: #e2426b;
      font-weight: 600;
    }
  }
}
.cer_css {
  .el-dialog__body {
    padding: 0px;
    position: relative;
  }
}
.cer_box {
  display: flex;
  width: 100%;
  padding: 0 24px 24px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  background: #fff;
  border-radius: 8px;
  .cer_box_txt {
    color: #000;

    font-style: normal;
    font-weight: 400;
    line-height: 21px; /* 150% */
  }
  .cer_box_card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;

    .cer_box_card_tag {
      display: flex;
      padding: 5px 12px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      border-radius: 0 21px 0 0;
      background: linear-gradient(180deg, #ff6a00 0%, #ed0000 100%);

      color: #fff;

      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }
    .cer_box_card_txt {
      display: flex;
      gap: 5px;

      color: #000;

      font-weight: 400;
      line-height: 21px;
    }
    .cer_box_line {
      width: 100%;
      height: 1px;
      background: var(---200, #e1e1e2);
    }
  }
}
.tit_message {
  position: relative;
  top: -15px;
  line-height: 20px;
  text-indent: 2em;
  margin: 0 20px;
  color: #c9841d;
}
/deep/ .el-dialog__footer {
  display: flex;
  justify-content: center;
}
.xn_css {
  display: inline-flex;
  padding: 4px 6px;
  align-items: center;
  gap: 4px;
  border-radius: 31px;
  border: 1px solid var(--Gray-Gray4-, #dcdcdc);
  background: #fff;
  height: 32px;
  // margin: 0 10px 0 0;
}
.xn_css:hover {
  cursor: pointer;
  border: 1px solid var(--Gray-Gray4-, #dcdcdc);
  background: var(--Gray-Gray2, #eee);
}
.el-main {
  // padding: 0 !important;
}
.main_css {
  // width: calc(100% - 40px) !important;
  width: calc(100% - 0px) !important;
  height: calc(100vh - 120px) !important;
  overflow-x: scroll;
  overflow-y: hidden;
  background: #ffffff;
  background-color: #e9eef3;
  // margin: 20px;

  // margin: 10px;
  //   overflow-y: hidden;
}
.main_css::-webkit-scrollbar {
  width: 0px;
  height: 10px;
}
.main_css::-webkit-scrollbar-thumb {
  //滑块部分
  border-radius: 5px;
  background-color: #b1b0b0;
}
.main_css::-webkit-scrollbar-track {
  //轨道部分
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ffffff;
  border-radius: 5px;
}
.kefu_css {
  position: absolute; /* 使用绝对定位来让元素可以自由移动 */
  // cursor: move; /* 鼠标移到元素上显示为移动光标 */
  z-index: 2001;
  .el-icon-circle-close {
    position: absolute;
    top: 20px;
    right: -0px;
    font-size: 19px;
    // cursor: pointer;
    display: none;
    z-index: 2010;
  }
}
.kefu_css:hover {
  .el-icon-circle-close {
    display: block;
  }
}
.cssSuspended {
  width: 100%;
  height: 120px;

  position: absolute;
  top: 63px;
  border-radius: 10px;
  .place_css {
    width: 100%;
    height: 60px;
    cursor: pointer;
  }
}
.kefu_wrapper {
  position: relative;
  height: 70px; /* 默认只露出顶部 40px */
  width: 60px;
  overflow: hidden;
  transition: height 0.3s ease;
}

/* 全部内容，贴顶部，无需 transform 动画 */
.kefu_css_ {
  position: absolute;
  top: 0;
  left: 0;
  height: 205px;
  padding: 10px 0 0 0;
}

/* 展开：容器高度变为完整内容高度，向下展开 */
.kefu_wrapper.expanded {
  height: 205px;
}
.firstMenu_one {
  height: 44px;
  line-height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-radius: 8px;

  .leftBox {
    display: flex;
    align-items: center;
    gap: 8px;

    .icon {
      width: 20px;
      height: 20px;
      vertical-align: middle;
    }
  }
}
.firstMenu_one_home:hover {
  background-color: #ffe9ef;
  cursor: pointer;
}
.subMenu_two {
  display: flex;
  padding: 0 16px;
  // flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  .subItemBox_two {
    width: calc(50% - 6px);
    color: var(---, #666b75);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .subItemBox_two:hover {
    color: #e2426b;
    cursor: pointer;
  }
  .subMenu_active_two {
    color: #e2426b;
    cursor: pointer;
  }
  .dropdown_tit:hover {
    // color: #e2426b;
    cursor: pointer;
  }
}
.xn_css_fu {
  background: #fff;
  height: 48px;
  width: 154px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 25px;
  position: relative;
  right: -12px;
  .xn_reminder {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 120px;
    .reminder_line {
      width: 1px;
      height: 70px;
      background: #fff;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -70px;
    }
    .reminder_box {
      display: flex;
      width: 405px;
      padding: 4px 4px 8px 4px;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      border-radius: 8px;
      background: #fff;
      img {
        width: 100%;
        height: 163px;
      }
      .reminder_txt {
        width: 100%;
        color: var(---, #383b41);
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
      }
      .reminder_btn_s {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        align-self: stretch;
        .reminder_btn {
          display: flex;
          height: 36px;
          padding: 7px 12px;
          justify-content: center;
          align-items: center;
          gap: 8px;

          border-radius: 8px;
          border: 1px solid var(---, #e4e5e8);
          background: var(--Gray-White, #fff);

          color: var(---, #666b75);
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          cursor: pointer;
        }
      }
    }
  }
}
.mask_css {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  opacity: 0.5;
  background: #000;
  z-index: 2010;
}
</style>
<style>
.menu_drop_css {
  margin-top: 5px !important;
  padding: 0px 0 !important;
}

.menu_drop_css .popper__arrow {
  display: none !important;
}
.menu_drop_css .el-dropdown-menu__item {
  display: flex;
  padding: 8px 32px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px 4px 0 0;
  background: #fff;
  color: var(---, #666b75);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
}
.menu_drop_css .el-dropdown-menu__item:hover {
  background: linear-gradient(0deg, #ffe9ef 0%, #ffe9ef 100%), #fff;
  color: var(---, #383b41) !important;
}
.menu_drop_css .is_drop_active {
  background: linear-gradient(0deg, #ffe9ef 0%, #ffe9ef 100%), #fff;
  color: var(---, #383b41) !important;
}
.product-expired-dialog {
  border-radius: 8px !important;
  overflow: hidden;

  .el-dialog__header {
    display: block;
    padding: 20px 24px 0;
    margin-right: 0;
  }

  .el-dialog__headerbtn {
    top: 20px;
    right: 20px;
    font-size: 16px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #909399;
  }

  .product-expired-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #262729;
    line-height: 24px;
  }

  .el-dialog__body {
    padding: 16px 24px 24px;
  }

  .product-expired-dialog__body {
    min-height: 72px;
  }

  .product-expired-dialog__text,
  .product-expired-dialog__contact {
    margin: 0;
    color: #6b6e73;
    font-size: 14px;
    line-height: 24px;
  }

  .product-expired-dialog__text {
    margin-bottom: 8px;
  }

  .product-expired-dialog__footer {
    display: flex;
    justify-content: flex-end;
    padding-top: 24px;
  }

  .product-expired-dialog__btn {
    min-width: 72px;
    padding: 8px 20px;
    color: #fff !important;
    background: #e2426b !important;
    border: none !important;
    border-radius: 4px;
  }
}
</style>
<style  lang="less" scoped>
.cer_css {
  .el-dialog__body {
    padding: 0px;
    position: relative;
  }
}
.cer_box {
  display: flex;
  width: 100%;
  padding: 0 24px 24px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  background: #fff;
  border-radius: 8px;
  .cer_box_txt {
    color: #000;

    font-style: normal;
    font-weight: 400;
    line-height: 21px; /* 150% */
  }
  .cer_box_card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;

    .cer_box_card_tag {
      display: flex;
      padding: 5px 12px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      border-radius: 0 21px 0 0;
      background: linear-gradient(180deg, #ff6a00 0%, #ed0000 100%);

      color: #fff;

      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }
    .cer_box_card_txt {
      display: flex;
      gap: 5px;

      color: #000;

      font-weight: 400;
      line-height: 21px;
    }
    .cer_box_line {
      width: 100%;
      height: 1px;
      background: var(---200, #e1e1e2);
    }
  }
}
.reward_tab {
  display: flex;
  /* background: #F5F5F5; */
  padding: 10px 0;
  margin: 10px 0 5px 0;
  position: relative;
}

.tab_th_1,
.tab_th_2,
.tab_th_4 {
  width: calc(33% - 0px);
}

.tab_th_4 {
  width: 34%;
  position: absolute;
  top: 0px;
  right: 0;
  border-radius: 8px;
  padding: 10px 0;
  border: 1px solid #fff0cf;
  background: linear-gradient(180deg, #ffeabc 0%, #ffce61 100%);
  /* padding: 50rpx 0;
    position: relative;
    top: -50rpx; */
}

.tab_td_1,
.tab_td_2,
.tab_td_3,
.tab_td_4 {
  line-height: 30px;
  text-align: center;
  font-size: 13px;
}

.tab_td_1,
.tab_td_2,
.tab_td_4 {
  padding: 12px 16px;
  line-height: 21px;
}

.tab_th_3 {
  width: calc(1% + 45px);
}

.tab_td_3 {
  color: #f56c6c;
  font-weight: 600;
  font-style: italic;
}

.tab_td_1 {
  color: #979797;
  font-weight: 600;
}

.tab_td_2 {
  font-weight: 600;
}

.tab_td_4 {
  color: #8dc0fd;
  font-weight: 600;
}
.cer_box_con {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  width: 100%;
  // align-items: flex-start;
  gap: 8px;
  // align-self: stretch;
  .cer_box_con_left {
    width: calc(100% - 230px);
  }
}
.cer_box_con_right {
  display: flex;
  // height: 249px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
  flex: 1 0 0;
  border-left: 1px solid var(---200, #e1e1e2);
  background: #fff;
}
.cer_box_con_right_top {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.bottom_txt {
  width: 100%;
  text-align: center;
  position: relative;
  top: -20px;
  left: 5px;
}
.badge_fixed__ {
  position: absolute;
  top: 0;
  right: 10px;
  transform: translateY(-50%) translateX(100%);

  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #fff;
}
</style>
